var Rr = Object.defineProperty;
var jr = (t, e, o) => e in t ? Rr(t, e, { enumerable: !0, configurable: !0, writable: !0, value: o }) : t[e] = o;
var M = (t, e, o) => (jr(t, typeof e != "symbol" ? e + "" : e, o), o);
import { enqueueSnackbar as Ye, SelectAdvanceComponents as Ne, Box as E, Avatar as _e, Typography as U, Chip as at, Tooltip as Re, useDebounceValue as He, SelectAdvancePopover as Cr, TypoTooltip as ue, TextField as ot, Link as Et, Alert as Ar, Breadcrumbs as Er, Dialog as _r, DialogContent as kr, Button as Ke, Badge as st, IconButton as Ue, usePopupState as _t, ButtonBase as Ge, bindToggle as kt, Popper as Tt, bindPopper as Ot, ClickAwayListener as Lt, Paper as Pt, Skeleton as Pe, useClipboard as Tr, Divider as It, sx as Dt } from "@applift/factor";
import { useQuery as ke, useInfiniteQuery as Nt } from "@tanstack/react-query";
import ye from "axios";
import * as m from "react";
import Ut from "react";
import { CurrencyDollar as Or, SemanticWarning as Lr, InfoCircle as Pr, CreativeImage as zt, CreativeHTML as Dr, CreativeVideo as Nr, CreativeNative as Ur, CreativeAudio as zr, IoCurrency as Fr, IoImpression as Mr, StatusDraft as Br, StatusPending as Ft, StatusPaused as Mt, StatusRunning as $r, StatusExpired as Wr, StatusDeleted as qr, StatusRejected as Bt, StatusFailed as Vr, AppCustomers as Kr, AppDashboard as Yr, AppInventory as Hr, AppReports as Gr, AppOrganisation as Jr, AppMyProfile as Qr, AppCampaigns as Xr, AppCreatives as Zr, AppAudiences as en, AppConversion as tn, AppBidModel as rn, AppInsights as nn, AppPlanner as an, ChevronRight as on, Message as sn, GridDots as cn, Copy as $t, Crown as Wt, ClipboardRemove as ln, Search as un, Home as dn, QuestionCircle as pn, StatusApproved as fn, StatusInvited as mn } from "@applift/icons";
import me from "clsx";
import { datadogRum as qe } from "@datadog/browser-rum";
import { DigitalExperience as gn } from "@applift/illustrations";
let qt;
function hn(t) {
  qt = t;
}
function we() {
  return qt || ye;
}
const Vt = "11,13,14", yn = (t) => {
  const e = {};
  for (const [o] of Object.entries(t ?? {}))
    e[o] = !0;
  return e;
}, Kt = (t) => Array.isArray(t) ? t.map((e) => ({
  value: `provider-${e.providerId}`,
  preservedValue: `${e.providerId}`,
  isProvider: !0,
  label: e.providerName,
  description: e.description,
  providerId: e.providerId,
  providerName: e.providerName,
  providerLogoUrl: e.providerLogoUrl,
  parentPathKey: null,
  cpm: 0,
  isLeaf: !1,
  creativeTypeIdList: [],
  creativeTypeIdSerialized: "",
  isAllCreativeType: !1,
  subRows: Yt(e.childSegments, e)
})) : [], Yt = (t, e) => Array.isArray(t) ? t.map((o) => {
  const r = (o.creativeTypeIdList ?? []).sort().join(",");
  return {
    value: o.isLeaf ? `${o.prebidAudienceSegmentId}` : `intermediate-segment-${o.prebidAudienceSegmentId}`,
    preservedValue: `${o.prebidAudienceSegmentId}`,
    isProvider: !1,
    label: o.prebidAudienceSegmentName,
    description: o.description,
    parentPathKey: o.parentPathKey,
    cpm: o.cpm,
    creativeTypeIdList: o.creativeTypeIdList ?? [],
    creativeTypeIdSerialized: r,
    isAllCreativeType: r === Vt,
    isLeaf: o.isLeaf,
    subRows: [],
    providerId: e.providerId,
    providerName: e.providerName,
    providerLogoUrl: e.providerLogoUrl
  };
}) : [], wn = (t, e = {}) => Array.isArray(t) ? t.map((r) => {
  var s, l;
  const i = (r.creativeTypeIdList ?? []).sort().join(",");
  return {
    value: `${r.prebidAudienceSegmentId}`,
    preservedValue: `${r.prebidAudienceSegmentId}`,
    isProvider: !1,
    label: r.prebidAudienceSegmentName,
    description: r.description,
    parentPathKey: r.parentPathKey,
    cpm: r.cpm,
    creativeTypeIdList: r.creativeTypeIdList ?? [],
    creativeTypeIdSerialized: i,
    isAllCreativeType: i === Vt,
    isLeaf: r.isLeaf,
    subRows: [],
    providerId: r.providerId,
    providerName: ((s = e == null ? void 0 : e[r.providerId]) == null ? void 0 : s.providerName) ?? "",
    providerLogoUrl: ((l = e == null ? void 0 : e[r.providerId]) == null ? void 0 : l.providerLogoUrl) ?? ""
  };
}) : [], vn = (t, e = {}) => {
  const r = wn(
    t,
    e
  ).reduce(
    (s, l) => {
      if (Array.isArray(s[l.providerId])) {
        const c = s[l.providerId];
        return c.push(l), { ...s, [l.providerId]: c };
      }
      const d = [l];
      return { ...s, [l.providerId]: d };
    },
    {}
  ), i = [];
  for (const [s, l] of Object.entries(
    r
  )) {
    const d = Kt([
      e[s]
    ]);
    l.forEach((j) => {
      In(
        d,
        Number(s),
        j.parentPathKey,
        j
      );
    });
    const c = d[0];
    i.push(c);
  }
  return i;
}, bn = (t, e, o) => {
  const r = [e.providerName, ...o, t].join(".");
  return {
    label: t,
    description: "",
    parentPathKey: o.join(" > "),
    creativeTypeIdList: [],
    creativeTypeIdSerialized: "",
    isAllCreativeType: !1,
    isLeaf: !1,
    cpm: 0,
    value: r,
    preservedValue: r,
    isProvider: !1,
    providerId: e.providerId,
    providerName: e.providerName ?? "",
    providerLogoUrl: e.providerLogoUrl ?? "",
    subRows: []
  };
}, In = (t, e, o, r) => {
  const i = o.split(">").map((l) => l.trim());
  if (i.length <= 0)
    return t;
  const s = t.filter(
    (l) => l.providerId === e
  )[0];
  return s ? rt(
    s.subRows,
    i.slice(),
    r,
    s,
    // provider data
    []
  ) : t;
}, rt = (t, e, o, r, i) => {
  if (e.length > 0) {
    const s = e.splice(0, 1)[0], l = i.slice();
    l.push(s);
    const d = t.find((c) => c.label === s);
    if (d)
      rt(
        d.subRows,
        e,
        o,
        r,
        l
      );
    else {
      const c = bn(
        s,
        r,
        i
      );
      t.push(c), rt(c.subRows, e, o, r, l);
    }
  } else
    t.push(o);
}, xn = async () => {
  var t;
  try {
    const e = await we().get("/v3/audience/prebid/provider/details/list"), { totalRecords: o, filteredRecords: r, prebidSegmentData: i } = e.data.data;
    return {
      totalRecords: o,
      filteredRecords: r,
      prebidSegmentData: Kt(i)
    };
  } catch (e) {
    return Promise.reject((t = e == null ? void 0 : e.response) == null ? void 0 : t.data);
  }
}, Sn = async ({
  prebidAudienceSegmentId: t,
  providerDetails: e
}) => {
  var o;
  try {
    const r = await we().get("/v3/audience/prebid/segment/details/list", {
      params: { prebidAudienceSegmentId: t }
    }), { totalRecords: i, filteredRecords: s, prebidSegmentData: l } = r.data.data;
    return {
      totalRecords: i,
      filteredRecords: s,
      prebidSegmentData: Yt(
        l,
        e
      )
    };
  } catch (r) {
    return Promise.reject((o = r == null ? void 0 : r.response) == null ? void 0 : o.data);
  }
}, Rn = async ({
  queryKey: t,
  signal: e,
  meta: o
}) => {
  var l;
  const { searchValue: r } = t[0], { CancelToken: i } = ye, s = i.source();
  e == null || e.addEventListener("abort", () => {
    s.cancel("v3/audience/prebid/details/search/list - Request cancelled");
  });
  try {
    const d = await we().post(
      "/v3/audience/prebid/details/search/list",
      { searchField: r },
      {
        cancelToken: s.token
      }
    ), { prebidSegmentData: c, totalRecords: j, filteredRecords: w } = d.data.data;
    return {
      totalRecords: j,
      filteredRecords: w,
      prebidSegmentData: vn(
        c,
        o
      )
    };
  } catch (d) {
    return Promise.reject((l = d.response) == null ? void 0 : l.data);
  }
}, jn = {
  keys: (t) => [t]
}, Cn = {
  keys: (t) => [t]
}, An = {
  keys: (t) => [t]
}, En = {
  keys: (t) => [t]
}, _n = {
  keys: (t) => [t]
}, it = {
  keys: (t) => [t]
}, kn = {
  keys: (t) => [t]
}, Ht = (t) => {
  var e, o;
  (o = Ye) == null || o(
    t.errorObjects ? (e = t.errorObjects[0]) == null ? void 0 : e.error : "Something went wrong!",
    {
      variant: "error"
    }
  );
}, Tn = (t) => ke(
  jn.keys({
    scope: "getPrebidProviderData"
  }),
  xn,
  {
    onError: Ht,
    enabled: t == null ? void 0 : t.enabled
  }
), On = (t, e) => ke(
  Cn.keys({
    scope: "getPrebidSearchSegmentData",
    searchValue: t
  }),
  Rn,
  {
    onError: Ht,
    enabled: e == null ? void 0 : e.enabled,
    meta: e == null ? void 0 : e.meta
  }
);
var nt = { exports: {} }, Me = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var xt;
function Ln() {
  if (xt)
    return Me;
  xt = 1;
  var t = Ut, e = Symbol.for("react.element"), o = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, i = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(d, c, j) {
    var w, A = {}, S = null, C = null;
    j !== void 0 && (S = "" + j), c.key !== void 0 && (S = "" + c.key), c.ref !== void 0 && (C = c.ref);
    for (w in c)
      r.call(c, w) && !s.hasOwnProperty(w) && (A[w] = c[w]);
    if (d && d.defaultProps)
      for (w in c = d.defaultProps, c)
        A[w] === void 0 && (A[w] = c[w]);
    return { $$typeof: e, type: d, key: S, ref: C, props: A, _owner: i.current };
  }
  return Me.Fragment = o, Me.jsx = l, Me.jsxs = l, Me;
}
var Be = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var St;
function Pn() {
  return St || (St = 1, process.env.NODE_ENV !== "production" && function() {
    var t = Ut, e = Symbol.for("react.element"), o = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), l = Symbol.for("react.provider"), d = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), j = Symbol.for("react.suspense"), w = Symbol.for("react.suspense_list"), A = Symbol.for("react.memo"), S = Symbol.for("react.lazy"), C = Symbol.for("react.offscreen"), z = Symbol.iterator, H = "@@iterator";
    function te(n) {
      if (n === null || typeof n != "object")
        return null;
      var u = z && n[z] || n[H];
      return typeof u == "function" ? u : null;
    }
    var x = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function k(n) {
      {
        for (var u = arguments.length, f = new Array(u > 1 ? u - 1 : 0), b = 1; b < u; b++)
          f[b - 1] = arguments[b];
        X("error", n, f);
      }
    }
    function X(n, u, f) {
      {
        var b = x.ReactDebugCurrentFrame, D = b.getStackAddendum();
        D !== "" && (u += "%s", f = f.concat([D]));
        var F = f.map(function(O) {
          return String(O);
        });
        F.unshift("Warning: " + u), Function.prototype.apply.call(console[n], console, F);
      }
    }
    var T = !1, B = !1, ae = !1, G = !1, W = !1, V;
    V = Symbol.for("react.module.reference");
    function v(n) {
      return !!(typeof n == "string" || typeof n == "function" || n === r || n === s || W || n === i || n === j || n === w || G || n === C || T || B || ae || typeof n == "object" && n !== null && (n.$$typeof === S || n.$$typeof === A || n.$$typeof === l || n.$$typeof === d || n.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      n.$$typeof === V || n.getModuleId !== void 0));
    }
    function Z(n, u, f) {
      var b = n.displayName;
      if (b)
        return b;
      var D = u.displayName || u.name || "";
      return D !== "" ? f + "(" + D + ")" : f;
    }
    function Q(n) {
      return n.displayName || "Context";
    }
    function ee(n) {
      if (n == null)
        return null;
      if (typeof n.tag == "number" && k("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof n == "function")
        return n.displayName || n.name || null;
      if (typeof n == "string")
        return n;
      switch (n) {
        case r:
          return "Fragment";
        case o:
          return "Portal";
        case s:
          return "Profiler";
        case i:
          return "StrictMode";
        case j:
          return "Suspense";
        case w:
          return "SuspenseList";
      }
      if (typeof n == "object")
        switch (n.$$typeof) {
          case d:
            var u = n;
            return Q(u) + ".Consumer";
          case l:
            var f = n;
            return Q(f._context) + ".Provider";
          case c:
            return Z(n, n.render, "ForwardRef");
          case A:
            var b = n.displayName || null;
            return b !== null ? b : ee(n.type) || "Memo";
          case S: {
            var D = n, F = D._payload, O = D._init;
            try {
              return ee(O(F));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var oe = Object.assign, ne = 0, re, q, se, y, p, h, I;
    function P() {
    }
    P.__reactDisabledLog = !0;
    function N() {
      {
        if (ne === 0) {
          re = console.log, q = console.info, se = console.warn, y = console.error, p = console.group, h = console.groupCollapsed, I = console.groupEnd;
          var n = {
            configurable: !0,
            enumerable: !0,
            value: P,
            writable: !0
          };
          Object.defineProperties(console, {
            info: n,
            log: n,
            warn: n,
            error: n,
            group: n,
            groupCollapsed: n,
            groupEnd: n
          });
        }
        ne++;
      }
    }
    function ie() {
      {
        if (ne--, ne === 0) {
          var n = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: oe({}, n, {
              value: re
            }),
            info: oe({}, n, {
              value: q
            }),
            warn: oe({}, n, {
              value: se
            }),
            error: oe({}, n, {
              value: y
            }),
            group: oe({}, n, {
              value: p
            }),
            groupCollapsed: oe({}, n, {
              value: h
            }),
            groupEnd: oe({}, n, {
              value: I
            })
          });
        }
        ne < 0 && k("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var de = x.ReactCurrentDispatcher, he;
    function pe(n, u, f) {
      {
        if (he === void 0)
          try {
            throw Error();
          } catch (D) {
            var b = D.stack.trim().match(/\n( *(at )?)/);
            he = b && b[1] || "";
          }
        return `
` + he + n;
      }
    }
    var g = !1, R;
    {
      var $ = typeof WeakMap == "function" ? WeakMap : Map;
      R = new $();
    }
    function ce(n, u) {
      if (!n || g)
        return "";
      {
        var f = R.get(n);
        if (f !== void 0)
          return f;
      }
      var b;
      g = !0;
      var D = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var F;
      F = de.current, de.current = null, N();
      try {
        if (u) {
          var O = function() {
            throw Error();
          };
          if (Object.defineProperty(O.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(O, []);
            } catch (xe) {
              b = xe;
            }
            Reflect.construct(n, [], O);
          } else {
            try {
              O.call();
            } catch (xe) {
              b = xe;
            }
            n.call(O.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (xe) {
            b = xe;
          }
          n();
        }
      } catch (xe) {
        if (xe && b && typeof xe.stack == "string") {
          for (var _ = xe.stack.split(`
`), le = b.stack.split(`
`), Y = _.length - 1, J = le.length - 1; Y >= 1 && J >= 0 && _[Y] !== le[J]; )
            J--;
          for (; Y >= 1 && J >= 0; Y--, J--)
            if (_[Y] !== le[J]) {
              if (Y !== 1 || J !== 1)
                do
                  if (Y--, J--, J < 0 || _[Y] !== le[J]) {
                    var ge = `
` + _[Y].replace(" at new ", " at ");
                    return n.displayName && ge.includes("<anonymous>") && (ge = ge.replace("<anonymous>", n.displayName)), typeof n == "function" && R.set(n, ge), ge;
                  }
                while (Y >= 1 && J >= 0);
              break;
            }
        }
      } finally {
        g = !1, de.current = F, ie(), Error.prepareStackTrace = D;
      }
      var Le = n ? n.displayName || n.name : "", bt = Le ? pe(Le) : "";
      return typeof n == "function" && R.set(n, bt), bt;
    }
    function fe(n, u, f) {
      return ce(n, !1);
    }
    function ve(n) {
      var u = n.prototype;
      return !!(u && u.isReactComponent);
    }
    function be(n, u, f) {
      if (n == null)
        return "";
      if (typeof n == "function")
        return ce(n, ve(n));
      if (typeof n == "string")
        return pe(n);
      switch (n) {
        case j:
          return pe("Suspense");
        case w:
          return pe("SuspenseList");
      }
      if (typeof n == "object")
        switch (n.$$typeof) {
          case c:
            return fe(n.render);
          case A:
            return be(n.type, u, f);
          case S: {
            var b = n, D = b._payload, F = b._init;
            try {
              return be(F(D), u, f);
            } catch {
            }
          }
        }
      return "";
    }
    var Ie = Object.prototype.hasOwnProperty, je = {}, Ae = x.ReactDebugCurrentFrame;
    function K(n) {
      if (n) {
        var u = n._owner, f = be(n.type, n._source, u ? u.type : null);
        Ae.setExtraStackFrame(f);
      } else
        Ae.setExtraStackFrame(null);
    }
    function Te(n, u, f, b, D) {
      {
        var F = Function.call.bind(Ie);
        for (var O in n)
          if (F(n, O)) {
            var _ = void 0;
            try {
              if (typeof n[O] != "function") {
                var le = Error((b || "React class") + ": " + f + " type `" + O + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof n[O] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw le.name = "Invariant Violation", le;
              }
              _ = n[O](u, O, b, f, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Y) {
              _ = Y;
            }
            _ && !(_ instanceof Error) && (K(D), k("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", b || "React class", f, O, typeof _), K(null)), _ instanceof Error && !(_.message in je) && (je[_.message] = !0, K(D), k("Failed %s type: %s", f, _.message), K(null));
          }
      }
    }
    var ze = Array.isArray;
    function Je(n) {
      return ze(n);
    }
    function sr(n) {
      {
        var u = typeof Symbol == "function" && Symbol.toStringTag, f = u && n[Symbol.toStringTag] || n.constructor.name || "Object";
        return f;
      }
    }
    function ir(n) {
      try {
        return ut(n), !1;
      } catch {
        return !0;
      }
    }
    function ut(n) {
      return "" + n;
    }
    function dt(n) {
      if (ir(n))
        return k("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", sr(n)), ut(n);
    }
    var Fe = x.ReactCurrentOwner, cr = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pt, ft, Qe;
    Qe = {};
    function lr(n) {
      if (Ie.call(n, "ref")) {
        var u = Object.getOwnPropertyDescriptor(n, "ref").get;
        if (u && u.isReactWarning)
          return !1;
      }
      return n.ref !== void 0;
    }
    function ur(n) {
      if (Ie.call(n, "key")) {
        var u = Object.getOwnPropertyDescriptor(n, "key").get;
        if (u && u.isReactWarning)
          return !1;
      }
      return n.key !== void 0;
    }
    function dr(n, u) {
      if (typeof n.ref == "string" && Fe.current && u && Fe.current.stateNode !== u) {
        var f = ee(Fe.current.type);
        Qe[f] || (k('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', ee(Fe.current.type), n.ref), Qe[f] = !0);
      }
    }
    function pr(n, u) {
      {
        var f = function() {
          pt || (pt = !0, k("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", u));
        };
        f.isReactWarning = !0, Object.defineProperty(n, "key", {
          get: f,
          configurable: !0
        });
      }
    }
    function fr(n, u) {
      {
        var f = function() {
          ft || (ft = !0, k("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", u));
        };
        f.isReactWarning = !0, Object.defineProperty(n, "ref", {
          get: f,
          configurable: !0
        });
      }
    }
    var mr = function(n, u, f, b, D, F, O) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: n,
        key: u,
        ref: f,
        props: O,
        // Record the component responsible for creating this element.
        _owner: F
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: b
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: D
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function gr(n, u, f, b, D) {
      {
        var F, O = {}, _ = null, le = null;
        f !== void 0 && (dt(f), _ = "" + f), ur(u) && (dt(u.key), _ = "" + u.key), lr(u) && (le = u.ref, dr(u, D));
        for (F in u)
          Ie.call(u, F) && !cr.hasOwnProperty(F) && (O[F] = u[F]);
        if (n && n.defaultProps) {
          var Y = n.defaultProps;
          for (F in Y)
            O[F] === void 0 && (O[F] = Y[F]);
        }
        if (_ || le) {
          var J = typeof n == "function" ? n.displayName || n.name || "Unknown" : n;
          _ && pr(O, J), le && fr(O, J);
        }
        return mr(n, _, le, D, b, Fe.current, O);
      }
    }
    var Xe = x.ReactCurrentOwner, mt = x.ReactDebugCurrentFrame;
    function Oe(n) {
      if (n) {
        var u = n._owner, f = be(n.type, n._source, u ? u.type : null);
        mt.setExtraStackFrame(f);
      } else
        mt.setExtraStackFrame(null);
    }
    var Ze;
    Ze = !1;
    function et(n) {
      return typeof n == "object" && n !== null && n.$$typeof === e;
    }
    function gt() {
      {
        if (Xe.current) {
          var n = ee(Xe.current.type);
          if (n)
            return `

Check the render method of \`` + n + "`.";
        }
        return "";
      }
    }
    function hr(n) {
      {
        if (n !== void 0) {
          var u = n.fileName.replace(/^.*[\\\/]/, ""), f = n.lineNumber;
          return `

Check your code at ` + u + ":" + f + ".";
        }
        return "";
      }
    }
    var ht = {};
    function yr(n) {
      {
        var u = gt();
        if (!u) {
          var f = typeof n == "string" ? n : n.displayName || n.name;
          f && (u = `

Check the top-level render call using <` + f + ">.");
        }
        return u;
      }
    }
    function yt(n, u) {
      {
        if (!n._store || n._store.validated || n.key != null)
          return;
        n._store.validated = !0;
        var f = yr(u);
        if (ht[f])
          return;
        ht[f] = !0;
        var b = "";
        n && n._owner && n._owner !== Xe.current && (b = " It was passed a child from " + ee(n._owner.type) + "."), Oe(n), k('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', f, b), Oe(null);
      }
    }
    function wt(n, u) {
      {
        if (typeof n != "object")
          return;
        if (Je(n))
          for (var f = 0; f < n.length; f++) {
            var b = n[f];
            et(b) && yt(b, u);
          }
        else if (et(n))
          n._store && (n._store.validated = !0);
        else if (n) {
          var D = te(n);
          if (typeof D == "function" && D !== n.entries)
            for (var F = D.call(n), O; !(O = F.next()).done; )
              et(O.value) && yt(O.value, u);
        }
      }
    }
    function wr(n) {
      {
        var u = n.type;
        if (u == null || typeof u == "string")
          return;
        var f;
        if (typeof u == "function")
          f = u.propTypes;
        else if (typeof u == "object" && (u.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        u.$$typeof === A))
          f = u.propTypes;
        else
          return;
        if (f) {
          var b = ee(u);
          Te(f, n.props, "prop", b, n);
        } else if (u.PropTypes !== void 0 && !Ze) {
          Ze = !0;
          var D = ee(u);
          k("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", D || "Unknown");
        }
        typeof u.getDefaultProps == "function" && !u.getDefaultProps.isReactClassApproved && k("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function vr(n) {
      {
        for (var u = Object.keys(n.props), f = 0; f < u.length; f++) {
          var b = u[f];
          if (b !== "children" && b !== "key") {
            Oe(n), k("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", b), Oe(null);
            break;
          }
        }
        n.ref !== null && (Oe(n), k("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    function vt(n, u, f, b, D, F) {
      {
        var O = v(n);
        if (!O) {
          var _ = "";
          (n === void 0 || typeof n == "object" && n !== null && Object.keys(n).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var le = hr(D);
          le ? _ += le : _ += gt();
          var Y;
          n === null ? Y = "null" : Je(n) ? Y = "array" : n !== void 0 && n.$$typeof === e ? (Y = "<" + (ee(n.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : Y = typeof n, k("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Y, _);
        }
        var J = gr(n, u, f, D, F);
        if (J == null)
          return J;
        if (O) {
          var ge = u.children;
          if (ge !== void 0)
            if (b)
              if (Je(ge)) {
                for (var Le = 0; Le < ge.length; Le++)
                  wt(ge[Le], n);
                Object.freeze && Object.freeze(ge);
              } else
                k("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              wt(ge, n);
        }
        return n === r ? vr(J) : wr(J), J;
      }
    }
    function br(n, u, f) {
      return vt(n, u, f, !0);
    }
    function Ir(n, u, f) {
      return vt(n, u, f, !1);
    }
    var xr = Ir, Sr = br;
    Be.Fragment = r, Be.jsx = xr, Be.jsxs = Sr;
  }()), Be;
}
process.env.NODE_ENV === "production" ? nt.exports = Ln() : nt.exports = Pn();
var a = nt.exports;
const Dn = Ne.DefaultListOptionItemWrapper(
  {
    disableCheckbox: !0,
    selectionStyle: "none"
  }
), Nn = (t, e, o) => {
  if (t.original.isProvider)
    return /* @__PURE__ */ a.jsxs(E, { sx: { display: "flex", alignItems: "center" }, children: [
      /* @__PURE__ */ a.jsx(E, { sx: { pr: 8, py: 8 }, children: /* @__PURE__ */ a.jsx(
        _e,
        {
          size: 32,
          variant: "square",
          src: t.original.providerLogoUrl,
          alt: t.original.providerName,
          imgProps: {
            style: { objectFit: "cover" }
          }
        }
      ) }),
      /* @__PURE__ */ a.jsxs(E, { sx: { display: "flex", flexDirection: "column" }, children: [
        /* @__PURE__ */ a.jsx(U, { children: t.original.label }),
        /* @__PURE__ */ a.jsx(U, { variant: "label", sx: { textColor: "neutral-500" }, children: t.original.description })
      ] })
    ] });
  const r = Array.isArray(t.subRows) ? t.subRows.some((s) => s.original.isLeaf === !0) : !1, i = Array.isArray(t.subRows) ? t.subRows.every((s) => s.original.isAllCreativeType === !0) : !1;
  if (r) {
    const s = Math.max(...t.original.subRows.map((d) => d.cpm)), l = t.getIsSomeSelected() || t.getIsAllSubRowsSelected();
    return /* @__PURE__ */ a.jsxs(E, { sx: { display: "flex", alignItems: "center", gap: 4 }, children: [
      /* @__PURE__ */ a.jsx(U, { children: t.original.label }),
      /* @__PURE__ */ a.jsx(
        at,
        {
          label: /* @__PURE__ */ a.jsx(U, { weight: "normal", children: `${s.toFixed(
            2
          )} (CPM)` }),
          color: "secondary",
          icon: /* @__PURE__ */ a.jsx(Or, {}),
          size: "small"
        }
      ),
      e && l && i === !1 && /* @__PURE__ */ a.jsx(Re, { title: o, placement: "top", arrow: !0, children: /* @__PURE__ */ a.jsx(Lr, { color: "warning", fontSize: 24 }) }),
      /* @__PURE__ */ a.jsx(
        Re,
        {
          title: "This signifies the total cost of the segments within this specific category",
          placement: "top",
          arrow: !0,
          children: /* @__PURE__ */ a.jsx(Pr, { fontSize: 20, sx: { textColor: "neutral-400" } })
        }
      )
    ] });
  }
  return /* @__PURE__ */ a.jsx("span", { children: t.original.label });
}, Un = "Only one creative type (Display or Video) is supported per campaign; So, avoid grouping respective pre-bid segments in one audience.", zn = m.forwardRef((t, e) => {
  var q, se, y;
  const {
    initialData: o,
    onChange: r,
    warningText: i = Un,
    ...s
  } = t, l = Ne.useSelectAdvanceApiRef(), [d, c] = m.useState([]), j = m.useRef(d);
  j.current = d;
  const [w, A] = m.useState(
    yn(o)
  ), S = m.useRef(w);
  S.current = w;
  const C = m.useRef(
    new Map(
      Object.entries(o ?? {})
    )
  ), [z, H] = m.useState(void 0), [te, x] = m.useState({}), [k, X] = m.useState(""), T = He(k, 250), B = m.useRef(/* @__PURE__ */ new Map()), ae = (p) => {
    C.current.delete(p);
    const h = { ...w };
    delete h[p], A(h), typeof r == "function" && r(
      Object.fromEntries(C.current.entries()),
      "apiAction"
    );
  }, G = (p) => {
    try {
      const h = l.current.tableInstance.getRow(p);
      h && (C.current.set(h.id, h.original), A({ ...w, [h.id]: !0 }), typeof r == "function" && r(
        Object.fromEntries(C.current.entries()),
        "apiAction"
      ));
    } catch (h) {
      console.log(h), console.log("cannot add row that is not part of current dataset");
    }
  }, W = (p) => {
    const h = {};
    C.current.clear();
    for (const [I, P] of Object.entries(p))
      h[I] = !0, C.current.set(I, P);
    A(h), typeof r == "function" && r(
      Object.fromEntries(C.current.entries()),
      "apiAction"
    );
  };
  m.useImperativeHandle(e, () => ({
    getRowSelection: () => S.current,
    getRowSelectionData: () => C.current,
    getCurrentData: () => j.current,
    removeSelection: ae,
    setSelection: G,
    reinitializeRowSelection: W,
    getSegmentCache: () => B.current,
    clearSegmentCache: () => B.current.clear(),
    setSearch: X
  }));
  const V = m.useMemo(() => {
    var p;
    if (Object.keys(w).length > 0) {
      const h = C.current.entries(), I = h.next();
      if ((p = I == null ? void 0 : I.value) != null && p[1]) {
        let N = I.value[1].creativeTypeIdSerialized;
        for (const [ie, de] of h) {
          if (de.creativeTypeIdSerialized !== N && de.isAllCreativeType === !1)
            return !0;
          de.isAllCreativeType === !1 && (N = de.creativeTypeIdSerialized);
        }
      }
    }
    return !1;
  }, [w]), v = Tn(), Z = m.useMemo(() => v.isSuccess ? v.data.prebidSegmentData.reduce(
    (p, h) => (p[h.providerId] = {
      providerId: h.providerId,
      providerLogoUrl: h.providerLogoUrl,
      providerName: h.providerName,
      description: h.description
    }, p),
    {}
  ) : {}, [v.isSuccess, v.data]), Q = On(T, {
    enabled: !!T && Object.keys(Z).length >= 1,
    meta: Z
  });
  m.useEffect(() => {
    var p, h, I, P;
    T ? (l.current.tableInstance.setExpanded(!0), (((I = Q.data) == null ? void 0 : I.prebidSegmentData) ?? []).length <= 0 && Q.isLoading === !1 ? H("noResult") : H(void 0), c(((P = Q.data) == null ? void 0 : P.prebidSegmentData) ?? [])) : (l.current.tableInstance.resetExpanded(), (((p = v.data) == null ? void 0 : p.prebidSegmentData) ?? []).length <= 0 && v.isLoading === !1 ? H("noRows") : H(void 0), c(((h = v.data) == null ? void 0 : h.prebidSegmentData) ?? []));
  }, [
    v.isLoading,
    Q.isLoading,
    (q = v.data) == null ? void 0 : q.prebidSegmentData,
    (se = Q.data) == null ? void 0 : se.prebidSegmentData,
    T,
    l,
    H,
    c
  ]);
  const ee = async ({
    row: p,
    insertNestedData: h
  }) => {
    x((I) => ({ ...I, [p.id]: !0 }));
    try {
      let I = [];
      if (B.current.has(p.original.preservedValue))
        I = B.current.get(
          p.original.preservedValue
        );
      else {
        const N = await Sn({
          prebidAudienceSegmentId: Number(p.original.preservedValue),
          providerDetails: {
            providerId: p.original.providerId,
            providerName: p.original.providerName,
            providerLogoUrl: p.original.providerLogoUrl,
            description: "",
            childSegments: []
          }
        });
        I = N.prebidSegmentData, B.current.set(
          p.original.preservedValue,
          N.prebidSegmentData
        );
      }
      const P = [...p.getParentRows(), p].map((N) => N.id);
      c((N) => h({
        existingRows: N ?? [],
        subRowsToInsert: I,
        path: P,
        getRowId: (ie) => ie.value,
        subRowKey: "subRows"
      }));
    } catch (I) {
      console.log(I);
    }
    x((I) => {
      const P = { ...I };
      return delete P[p.id], P;
    });
  }, oe = () => {
    const p = C.current.entries(), h = l.current.tableInstance.getRowModel().rowsById, I = {};
    for (const P of p) {
      const [N, ie] = P;
      h[N] && (I[N] = ie);
    }
    return I;
  }, ne = (p) => {
    var pe;
    const h = typeof p == "function" ? p(w) : p, I = Object.keys(h), P = oe(), N = Object.keys(P), ie = l.current.tableInstance.getRowModel().rowsById, de = I.filter(
      (g) => P[g] === void 0
    ), he = N.filter(
      (g) => h[g] === void 0
    );
    for (const g of de)
      (pe = ie[g]) != null && pe.original && C.current.set(g, ie[g].original);
    for (const g of he)
      C.current.delete(g);
    A(p), typeof r == "function" && r(
      Object.fromEntries(C.current.entries()),
      "userAction"
    );
  }, re = m.useMemo(
    () => Object.keys(w).length,
    [w]
  );
  return (
    // @ts-ignore
    /* @__PURE__ */ a.jsx(
      Cr,
      {
        size: "small",
        ...s,
        data: d ?? [],
        apiRef: l,
        rowCount: d.length ?? 5,
        inputValue: k,
        multiple: !0,
        hideSelectNav: !0,
        hideSearch: !1,
        loading: T ? Q.isLoading : v.isLoading,
        renderContentTop: /* @__PURE__ */ a.jsxs(U, { sx: { px: 16, pt: 8, pb: 0 }, children: [
          re,
          " Segment",
          re > 1 ? "s" : "",
          " Selected"
        ] }),
        overlay: z,
        renderListItem: Dn,
        onFetchSubRows: ee,
        enableSubRowSelection: !1,
        getSubRows: (p) => {
          var h;
          return (((h = p.subRows) == null ? void 0 : h.length) ?? 0) > 0 ? p.subRows : void 0;
        },
        getRowCanExpand: (p) => {
          var h;
          return !(((h = p.original) == null ? void 0 : h.isLeaf) ?? !1);
        },
        renderOption: (p) => Nn(p.row, V, i),
        isRowLoading: te,
        value: w,
        onChange: ne,
        onInputChange: (p, h, I) => {
          I !== "reset" && X(h);
        },
        slotProps: {
          ...s.slotProps,
          PaperProps: {
            style: {
              maxWidth: "576px",
              width: "calc(100% - 64px)"
            },
            ...(y = s.slotProps) == null ? void 0 : y.PaperProps
          }
        }
      }
    )
  );
});
zn.displayName = "SelectPrebidSegment";
const Fn = (t) => {
  if (!Array.isArray(t))
    return [];
  const e = [];
  for (let o = 0; o < t.length; o++) {
    const r = t[o], i = {
      value: `${r.ioId}`,
      label: r.ioName,
      ioBudgetTypeId: r.ioBudgetTypeId,
      ioStatusId: r.ioStatusId,
      status: "",
      type: "IO",
      owId: r.owId,
      uowId: r.uowId,
      lastModified: r.lastModified,
      startTime: 0,
      endTime: 0,
      timezoneId: 0,
      creativeTypeId: -1,
      isLeaf: r.campaignCount <= 0,
      subRowsCount: r.campaignCount,
      subRows: Mn(r.campaigns)
    };
    e.push(i);
  }
  return e;
}, Mn = (t) => {
  if (!Array.isArray(t))
    return [];
  const e = [];
  for (let o = 0; o < t.length; o++) {
    const r = t[o], i = {
      value: `${r.id}`,
      label: r.name,
      ioBudgetTypeId: r.ioBudgetTypeId,
      ioStatusId: r.ioStatusId,
      status: r.status,
      type: "Campaign",
      owId: r.owId,
      uowId: 0,
      lastModified: r.modifiedAt,
      startTime: r.startTime,
      endTime: r.endTime,
      creativeTypeId: r.creativeTypeId,
      timezoneId: (r == null ? void 0 : r.timezoneId) ?? 0,
      isLeaf: !0,
      subRowsCount: 0,
      subRows: []
    };
    e.push(i);
  }
  return e;
}, Bn = (t) => {
  const e = {};
  for (const [o] of Object.entries(t ?? {}))
    e[o] = !0;
  return e;
}, Rt = {
  audience: "/v3/cmp/io/campaign/served/list",
  basic: "/v3/cmp/io/campaign/basic/list",
  conversion: "/v3/cmp/io/campaign/basic/list",
  // For campaign debugger
  basic2: "/v3/cd/campaign/basic-details-list"
}, $n = async ({
  queryKey: t,
  signal: e
}) => {
  var c;
  const { scope: o, useCase: r, ...i } = t[0], { CancelToken: s } = ye, l = s.source(), d = Rt[r] ?? Rt.basic;
  e == null || e.addEventListener("abort", () => {
    l.cancel(`${d} - Request cancelled`);
  });
  try {
    const j = await we().post(
      d,
      { ...i, pageNo: -1 },
      {
        cancelToken: l.token
      }
    ), { ioCampaignsList: w, totalRecords: A, filteredRecords: S } = j.data.data;
    return {
      totalRecords: A,
      filteredRecords: S,
      ioCampaignsList: Fn(w)
    };
  } catch (j) {
    return Promise.reject((c = j == null ? void 0 : j.response) == null ? void 0 : c.data);
  }
}, Wn = (t) => {
  var e, o;
  (o = Ye) == null || o(
    t.errorObjects ? (e = t.errorObjects[0]) == null ? void 0 : e.error : "Something went wrong!",
    {
      variant: "error"
    }
  );
}, qn = (t, e) => ke(
  An.keys({
    ...t,
    scope: "getIOCampaignListDataKey"
  }),
  $n,
  {
    onError: Wn,
    enabled: e == null ? void 0 : e.enabled,
    meta: e == null ? void 0 : e.meta
  }
), Vn = "_icons_1c6xj_1", Kn = "_status_1c6xj_6", De = {
  icons: Vn,
  status: Kn
}, Gt = {
  11: zt,
  13: Dr,
  14: Nr,
  15: Ur,
  17: zr
}, jt = {
  draft: /* @__PURE__ */ a.jsx(Br, { color: "info" }),
  pending: /* @__PURE__ */ a.jsx(Ft, { color: "warning" }),
  paused: /* @__PURE__ */ a.jsx(Mt, { color: "warning" }),
  running: /* @__PURE__ */ a.jsx($r, { color: "success" }),
  expired: /* @__PURE__ */ a.jsx(Wr, { color: "secondary" }),
  deleted: /* @__PURE__ */ a.jsx(qr, { color: "secondary" }),
  rejected: /* @__PURE__ */ a.jsx(Bt, { color: "error" }),
  failed: /* @__PURE__ */ a.jsx(Vr, {})
}, Yn = Ne.DefaultListOptionItemWrapper(
  {
    disableCheckbox: !0,
    disableRowExpansion: !0,
    selectionStyle: "all"
  }
), Hn = (t) => {
  if (t.original.type === "IO")
    return /* @__PURE__ */ a.jsxs(E, { sx: { display: "flex", alignItems: "center" }, children: [
      t.original.ioBudgetTypeId === 1 ? /* @__PURE__ */ a.jsx(
        Fr,
        {
          color: "primary",
          sx: { flexShrink: 0 },
          className: De.icons
        }
      ) : /* @__PURE__ */ a.jsx(
        Mr,
        {
          color: "primary",
          sx: { flexShrink: 0 },
          className: De.icons
        }
      ),
      /* @__PURE__ */ a.jsx(
        ue,
        {
          sx: { ml: 8, mr: 4 },
          TypgraphyProps: {
            weight: "demi"
          },
          children: t.original.label
        }
      ),
      /* @__PURE__ */ a.jsxs(
        E,
        {
          sx: { display: "flex", alignItems: "center", gap: 4, flexShrink: 0 },
          children: [
            /* @__PURE__ */ a.jsx(U, { sx: { textColor: "neutral-400" }, children: "•" }),
            /* @__PURE__ */ a.jsx(U, { variant: "label", sx: { textColor: "neutral-400" }, children: "ID" }),
            /* @__PURE__ */ a.jsx(U, { children: t.original.value })
          ]
        }
      )
    ] });
  if (t.original.type === "Campaign") {
    const e = (
      // @ts-ignore
      Gt[t.original.creativeTypeId]
    ), o = (
      // @ts-ignore
      jt[t.original.status] ?? jt.draft
    );
    return /* @__PURE__ */ a.jsxs(E, { sx: { display: "flex", alignItems: "start" }, children: [
      e ? /* @__PURE__ */ a.jsx(e, { color: "primary", className: De.icons }) : /* @__PURE__ */ a.jsx(
        zt,
        {
          className: De.icons,
          sx: { visibility: "hidden" }
        }
      ),
      /* @__PURE__ */ a.jsxs(
        E,
        {
          sx: {
            display: "flex",
            flexDirection: "column",
            ml: 8,
            overflow: "hidden",
            width: 100
          },
          children: [
            /* @__PURE__ */ a.jsx(
              ue,
              {
                TypgraphyProps: {
                  weight: "demi"
                },
                children: t.original.label
              }
            ),
            /* @__PURE__ */ a.jsxs(E, { sx: { display: "flex", alignItems: "center", gap: 4 }, children: [
              /* @__PURE__ */ a.jsxs(E, { sx: { display: "flex", alignItems: "center", gap: 4 }, children: [
                /* @__PURE__ */ a.jsx(
                  U,
                  {
                    variant: "label",
                    weight: "demi",
                    sx: { textColor: "neutral-500" },
                    children: "ID"
                  }
                ),
                /* @__PURE__ */ a.jsx(U, { component: "span", variant: "label", children: t.original.value })
              ] }),
              /* @__PURE__ */ a.jsx(U, { sx: { textColor: "neutral-400" }, children: "•" }),
              /* @__PURE__ */ a.jsxs(
                E,
                {
                  sx: {
                    display: "flex",
                    alignItems: "center",
                    gap: 4,
                    fontSize: 14
                  },
                  children: [
                    o,
                    /* @__PURE__ */ a.jsx(
                      U,
                      {
                        className: De.status,
                        variant: "label",
                        component: "span",
                        children: t.original.status
                      }
                    )
                  ]
                }
              )
            ] })
          ]
        }
      )
    ] });
  }
  return /* @__PURE__ */ a.jsx(E, {});
}, Gn = m.forwardRef((t, e) => {
  var se;
  const {
    initialData: o,
    onChange: r,
    params: i,
    useCase: s = "basic",
    multiple: l = !1,
    prepopulate: d = !1,
    TextFieldProps: c,
    slotProps: j,
    enabled: w = !0,
    ...A
  } = t, S = m.useState(0)[1], C = Ne.useSelectAdvanceApiRef(), [z, H] = m.useState(""), te = He(z, 250), { data: x, isLoading: k, isFetching: X } = qn(
    {
      ...i,
      useCase: s,
      searchField: te
    },
    {
      enabled: w
    }
  ), T = m.useRef(x);
  T.current = x;
  const B = m.useRef(!1), [ae, G] = m.useState(
    Bn(o)
  ), W = m.useRef(!1), V = m.useRef(ae);
  V.current = ae;
  const v = m.useRef(
    new Map(Object.entries(o ?? {}))
  );
  m.useEffect(() => {
    var y, p, h, I;
    if (d === !1) {
      B.current = !0;
      return;
    } else if (o && W.current === !1 && B.current === !1) {
      W.current = !0, B.current = !0;
      return;
    } else if (x && B.current === !1) {
      for (let P = 0; P < (((y = x == null ? void 0 : x.ioCampaignsList) == null ? void 0 : y.length) ?? 0); P++)
        if ((((h = (p = x.ioCampaignsList[P]) == null ? void 0 : p.subRows) == null ? void 0 : h.length) ?? 0) > 0) {
          const N = (I = x.ioCampaignsList[P]) == null ? void 0 : I.subRows[0];
          if (N) {
            G({ [N.value]: !0 }), v.current.set(N.value, N), typeof r == "function" && (r(
              Object.fromEntries(v.current.entries()),
              "prepopulate"
            ), setTimeout(() => S((ie) => ie + 1))), B.current = !0;
            return;
          }
        }
      typeof r == "function" && (r(
        Object.fromEntries(v.current.entries()),
        "prepopulate"
      ), setTimeout(() => S((P) => P + 1))), B.current = !0;
    }
  }, [x, d, G, r, S, o]);
  const Z = (y) => {
    v.current.delete(y);
    const p = { ...ae };
    delete p[y], G(p), typeof r == "function" && r(
      Object.fromEntries(v.current.entries()),
      "apiAction"
    );
  }, Q = (y) => {
    try {
      const p = C.current.tableInstance.getRow(y);
      p && (v.current.set(p.id, p.original), G({ ...ae, [p.id]: !0 }), typeof r == "function" && r(
        Object.fromEntries(v.current.entries()),
        "apiAction"
      ));
    } catch (p) {
      console.log(p), console.log("cannot add row that is not part of current dataset");
    }
  }, ee = (y) => {
    const p = {};
    v.current.clear();
    for (const [h, I] of Object.entries(y))
      p[h] = !0, v.current.set(h, I);
    G(p), typeof r == "function" && r(
      Object.fromEntries(v.current.entries()),
      "apiAction"
    );
  }, oe = (y = !0) => {
    B.current = !y, H(""), G({}), V.current = {}, v.current.clear();
  };
  m.useImperativeHandle(e, () => ({
    getRowSelection: () => V.current,
    getRowSelectionData: () => v.current,
    getCurrentData: () => {
      var y;
      return ((y = T == null ? void 0 : T.current) == null ? void 0 : y.ioCampaignsList) ?? [];
    },
    removeSelection: Z,
    setSelection: Q,
    reinitializeRowSelection: ee,
    setSearch: H,
    reset: oe
  }));
  const ne = () => {
    const y = v.current.entries(), p = C.current.tableInstance.getRowModel().rowsById, h = {};
    for (const I of y) {
      const [P, N] = I;
      p[P] && (h[P] = N);
    }
    return h;
  }, re = (y) => {
    var he, pe;
    const p = typeof y == "function" ? y(ae) : y;
    if (l === !1) {
      const g = Object.keys(p)[0], $ = (he = C.current.tableInstance.getRowModel().rowsById[g]) == null ? void 0 : he.original;
      v.current.clear(), v.current.set(g, $), G(y), typeof r == "function" && r(
        Object.fromEntries(v.current.entries()),
        "userAction"
      );
      return;
    }
    const h = Object.keys(p), I = ne(), P = Object.keys(I), N = C.current.tableInstance.getRowModel().rowsById, ie = h.filter(
      (g) => I[g] === void 0
    ), de = P.filter(
      (g) => p[g] === void 0
    );
    for (const g of ie)
      (pe = N[g]) != null && pe.original && v.current.set(g, N[g].original);
    for (const g of de)
      v.current.delete(g);
    G(y), typeof r == "function" && r(
      Object.fromEntries(v.current.entries()),
      "userAction"
    );
  };
  m.useEffect(() => {
    C.current.tableInstance.setExpanded(!0);
  }, [C]);
  const q = m.useMemo(() => {
    var y;
    if (!(k || X)) {
      if (!Array.isArray(x == null ? void 0 : x.ioCampaignsList))
        return "error";
      if ((((y = x == null ? void 0 : x.ioCampaignsList) == null ? void 0 : y.length) ?? 0) <= 0)
        return z ? "noResult" : "noRows";
    }
  }, [x, k, X, z]);
  return (
    // @ts-ignore
    /* @__PURE__ */ a.jsx(
      ot,
      {
        size: "medium",
        ...c,
        select: "advanceSelect",
        placeholder: "Select Campaign",
        SelectProps: {
          slotProps: {
            ...j,
            InputBaseProps: {
              placeholder: "Search by IO Name, IO ID, Campaign ID, Name",
              ...j == null ? void 0 : j.InputBaseProps
            }
          },
          ...A,
          data: (x == null ? void 0 : x.ioCampaignsList) ?? [],
          apiRef: C,
          rowCount: ((se = x == null ? void 0 : x.ioCampaignsList) == null ? void 0 : se.length) ?? 5,
          inputValue: z,
          multiple: l,
          loading: k || X,
          renderListItem: Yn,
          enableSubRowSelection: !0,
          getSubRows: (y) => {
            var p;
            return (((p = y.subRows) == null ? void 0 : p.length) ?? 0) > 0 ? y.subRows : void 0;
          },
          getRowCanExpand: (y) => {
            var p;
            return !(((p = y.original) == null ? void 0 : p.isLeaf) ?? !1);
          },
          overlay: q,
          onInputChange: (y, p, h) => {
            h !== "reset" && H(p);
          },
          renderValue: () => {
            const y = Object.keys(V.current);
            if (l)
              return y.length ? `${y.length} Selected` : "​";
            {
              const p = y[0] ?? "", h = v.current.get(p), I = (
                // @ts-ignore
                Gt[h.creativeTypeId]
              );
              return /* @__PURE__ */ a.jsxs(
                E,
                {
                  Component: "span",
                  sx: { display: "flex", gap: 4, overflow: "hidden" },
                  children: [
                    /* @__PURE__ */ a.jsx(E, { Component: "span", sx: { display: "flex", flexShrink: 0 }, children: I ? /* @__PURE__ */ a.jsx(I, { color: "primary", className: De.icons }) : null }),
                    /* @__PURE__ */ a.jsx(
                      ue,
                      {
                        TypgraphyProps: {
                          component: "span"
                        },
                        children: (h == null ? void 0 : h.label) ?? "​"
                      }
                    )
                  ]
                }
              );
            }
          },
          renderOption: ({ row: y }) => Hn(y)
        },
        value: ae,
        onChange: re
      }
    )
  );
});
Gn.displayName = "SelectIOCampaignList";
const Jn = 20, Se = {
  SUPER: "SUPER",
  WORKSPACE: "WORKSPACE",
  ADVERTISER: "ADVERTISER"
}, We = {
  AUTH: "auth",
  LAST_OWID: "last_owid",
  LEGACY_OWIDS_ARRAY: "owIds",
  LEGACY_AUTH: "authorizedUser"
}, Jt = {
  Customers: Kr,
  Dashboard: Yr,
  Inventory: Hr,
  Reports: Gr,
  Organization: Jr,
  "My Profile": Qr,
  Campaigns: Xr,
  Creatives: Zr,
  Audiences: en,
  Conversions: tn,
  "Bid Model": rn,
  Insights: nn,
  Planner: an
}, Qn = "_root_jpdt6_1", Xn = "_superUser_jpdt6_13", Zn = "_workspaceUser_jpdt6_17", ea = "_advertiserUser_jpdt6_21", ta = "_message_jpdt6_25", ra = "_chip_jpdt6_32", na = "_link_jpdt6_36", Ee = {
  root: Qn,
  superUser: Xn,
  workspaceUser: Zn,
  advertiserUser: ea,
  message: ta,
  chip: ra,
  link: na
}, ct = m.createContext({});
process.env.NODE_ENV !== "production" && (ct.displayName = "AppContext");
const Ce = () => m.useContext(ct), lt = () => {
  const t = window.location.host;
  return ["localhost", "127.0.0.1"].filter((o) => t.includes(o)).length > 0;
}, aa = () => {
  var o;
  let t = 0;
  lt() && (t = 0);
  const e = window.location.href ?? "";
  try {
    const r = Number((o = e.match(/\/u\/[0-9]+/i)) == null ? void 0 : o[0].substring(3));
    t = isNaN(r) ? 0 : r;
  } catch {
    t = 0;
  }
  return t;
}, oa = (t) => {
  try {
    const e = JSON.parse(
      window.localStorage.getItem(We.LEGACY_OWIDS_ARRAY) ?? ""
    );
    return Array.isArray(e) && e.length ? Number(e[t]) ?? null : null;
  } catch {
    return null;
  }
}, Ct = (t) => {
  try {
    const e = JSON.parse(
      window.localStorage.getItem(We.LEGACY_OWIDS_ARRAY) ?? ""
    ), o = e.map(Number);
    return Array.isArray(e) && e.length ? [o.indexOf(t), o] : [-1, o];
  } catch {
    return [-1, []];
  }
}, Qt = () => {
  const t = aa();
  return oa(t);
}, sa = () => {
  var o;
  let t = Number(
    localStorage.getItem(We.LAST_OWID)
  );
  if (t = isNaN(t) ? null : t, lt())
    return t;
  const e = window.location.href ?? "";
  try {
    const r = Number((o = e.match(/\/u\/[0-9]+/i)) == null ? void 0 : o[0].substring(3));
    t = isNaN(r) ? null : r;
  } catch {
    t = null;
  }
  return null;
}, tt = (t, e, o) => t.replace(new RegExp(`/u/${e}`, "i"), `/u/${o}`);
function ia(t, e) {
  let o, r, i, s = "";
  for (o in t)
    if ((i = t[o]) !== void 0)
      if (Array.isArray(i))
        for (r = 0; r < i.length; r++)
          s && (s += "&"), s += encodeURIComponent(o) + "=" + encodeURIComponent(i[r]);
      else
        s && (s += "&"), s += encodeURIComponent(o) + "=" + encodeURIComponent(i);
  return (e || "") + s;
}
const ca = la(
  JSON.stringify,
  JSON.parse
);
function la(t, e) {
  function o(r) {
    if (typeof r == "object" && r !== null)
      try {
        return t(r);
      } catch {
      }
    else if (typeof r == "string" && typeof e == "function")
      try {
        return e(r), t(r);
      } catch {
      }
    return r;
  }
  return (r) => {
    r = { ...r }, Object.keys(r).forEach((s) => {
      const l = r[s];
      typeof l > "u" || l === void 0 ? delete r[s] : r[s] = o(l);
    });
    const i = ia(r).toString();
    return i ? `?${i}` : "";
  };
}
const ua = () => {
  const t = window.localStorage.getItem(We.LEGACY_AUTH);
  if (t)
    try {
      const e = JSON.parse(t);
      return {
        accessToken: e.apiToken,
        refreshToken: e.refreshToken,
        tokenType: "bearer",
        expiresIn: e.expiresAt
      };
    } catch {
      return null;
    }
  return null;
};
class da {
  constructor(e) {
    M(this, "originURLFallback");
    M(this, "legacyMode");
    this.originURLFallback = e.originURLFallback, this.legacyMode = e.legacyMode;
  }
  get originURL() {
    return lt() ? this.originURLFallback ?? "" : window.location.origin;
  }
  get owIdHeaderKey() {
    return "X-IAA-OW-ID";
  }
  get OwIdFromPath() {
    return this.legacyMode ? Qt() : sa();
  }
}
class pa {
  constructor(e) {
    M(this, "authData");
    M(this, "profileData");
    M(this, "orgsHirerachy");
    M(this, "currentApp");
    M(this, "initAppInst");
    M(this, "legacyMode");
    M(this, "intercomId");
    /**
     * @deprecated
     * @returns string
     */
    M(this, "prepareAppSwitchingURLLegacy", (e) => {
      const [o] = Ct(this.loggedInOwId);
      return new URL(
        `${e.appUrl}/u/${o}/`,
        this.originURL
      ).toString();
    });
    M(this, "prepareAppSwitchingURLNew", (e) => new URL(
      `${e.appUrl}/u/${this.loggedInOwId}/`,
      this.originURL
    ).toString());
    M(this, "prepareAppSwitchingURL", (e) => this.legacyMode ? this.prepareAppSwitchingURLLegacy(e) : this.prepareAppSwitchingURLNew(e));
    /**
     *
     * @depricated
     * @return string
     */
    M(this, "prepareOrganizationSwitchingURLLegacy", (e) => {
      if (e.owId === this.loggedInOwId)
        return window.location.href;
      if (this.initAppInst.originURL.includes(e.workspaceDomain)) {
        const [r, i] = Ct(
          e.owId
        ), s = Qt();
        if (r === -1 && s) {
          const l = [...i, e.owId];
          return localStorage.setItem(
            We.LEGACY_OWIDS_ARRAY,
            JSON.stringify(l)
          ), tt(
            window.location.href,
            s,
            l.length - 1
          ).replace(window.location.hash, "");
        } else if (r && s)
          return tt(
            window.location.href,
            s,
            r
          ).replace(window.location.hash, "");
        return window.location.href;
      } else {
        const r = new URLSearchParams();
        return r.set("ow", `${e.owId}`), r.set("apiToken", btoa(this.authToken)), r.set("refreshToken", btoa(this.refreshToken)), r.set("expiresAt", `${this.authTokenExpiryInMilliseconds / 1e3}`), r.set("redirect_to", this.currentApp), `https://${e.workspaceDomain}/#/login?${r.toString()}`;
      }
    });
    M(this, "prepareOrganizationSwitchingURLNew", (e) => {
      if (e.owId === this.loggedInOwId)
        return window.location.href;
      if (this.initAppInst.originURL.includes(e.workspaceDomain))
        return tt(
          window.location.href,
          this.loggedInOwId,
          e.owId
        ).replace(window.location.hash, "");
      {
        const r = {
          authData: this.authData,
          owId: e.owId,
          redirectTo: this.currentApp
        }, i = ca(r);
        return `https://${e.workspaceDomain}/#/cross-login${i}`;
      }
    });
    M(this, "prepareOrganizationSwitchingURL", (e) => this.legacyMode ? this.prepareOrganizationSwitchingURLLegacy(e) : this.prepareOrganizationSwitchingURLNew(e));
    this.intercomId = e.intercomId, this.currentApp = e.currentApp, this.initAppInst = e.initAppIstance, this.legacyMode = e.legacyMode, this.authData = e.authData, this.profileData = e.profileData;
    const o = {
      organizationName: this.profileData.organizationName,
      owId: this.profileData.owId,
      // todo - figure out a way to get this data from init
      workspaceDomain: window.location.host,
      isAccess: !1
    };
    this.orgsHirerachy = [
      ...Xt(this.profileData.parentOrganization),
      o
    ];
  }
  get userEmail() {
    return this.profileData.email;
  }
  get userAvatar() {
    return this.profileData.userAvatar;
  }
  get isUserOrganizationOwner() {
    return this.profileData.isOwnerUser;
  }
  get userDisplayName() {
    return this.profileData.displayName;
  }
  get userFirstName() {
    return this.profileData.firstName;
  }
  get userLastName() {
    return this.profileData.lastName;
  }
  get isBetaUser() {
    return this.profileData.isBetaUser;
  }
  get organizationName() {
    return this.profileData.organizationName;
  }
  get organizationLogo() {
    return this.profileData.organizationLogo;
  }
  get organizationTimezone() {
    return this.profileData.organizationTimezone;
  }
  get organizationType() {
    return this.profileData.isPlatformOwnerOrg ? Se.SUPER : this.profileData.isWorkspaceOwnerOrg ? Se.WORKSPACE : Se.ADVERTISER;
  }
  get isInfobarEnabled() {
    return this.organizationType === "SUPER" || this.organizationType === "WORKSPACE" ? !0 : this.organizationType === "ADVERTISER" && this.profileData.parentOrganization;
  }
  get loggedInOwId() {
    return this.profileData.owId;
  }
  get organizationHirerachy() {
    return this.orgsHirerachy;
  }
  get authToken() {
    return this.authData.accessToken;
  }
  get authTokenExpiryInMilliseconds() {
    return this.authData.expiresIn * 1e3;
  }
  get refreshToken() {
    return this.authData.refreshToken;
  }
  get originURL() {
    return this.initAppInst.originURL;
  }
  get owIdHeaderKey() {
    return this.initAppInst.owIdHeaderKey;
  }
}
const Xt = (t) => {
  let e = [];
  if (t) {
    const { parentOrganization: o, ...r } = t;
    return o && (e = Xt(o)), e.push(r), e;
  }
  return [];
}, fa = async ({
  queryKey: t,
  signal: e
}) => {
  var i;
  t[0];
  const { CancelToken: o } = ye, r = o.source();
  e == null || e.addEventListener("abort", () => {
    r.cancel("/v3/ua/profile - Request cancelled");
  });
  try {
    const s = await we().get("/v3/ua/profile", {
      cancelToken: r.token
    }), { data: l } = s.data;
    return l;
  } catch (s) {
    return Promise.reject((i = s == null ? void 0 : s.response) == null ? void 0 : i.data);
  }
}, ma = async ({
  queryKey: t,
  signal: e
}) => {
  var i;
  t[0];
  const { CancelToken: o } = ye, r = o.source();
  e == null || e.addEventListener("abort", () => {
    r.cancel("/v3/ua/chatbot - Request cancelled");
  });
  try {
    const s = await we().get("/v3/ua/chatbot", {
      cancelToken: r.token
    }), { data: l } = s.data;
    return l;
  } catch (s) {
    return Promise.reject((i = s == null ? void 0 : s.response) == null ? void 0 : i.data);
  }
}, ga = async ({
  queryKey: t,
  signal: e
}) => {
  var i;
  t[0];
  const { CancelToken: o } = ye, r = o.source();
  e == null || e.addEventListener("abort", () => {
    r.cancel("/v3/ua/user/allowed-applications - Request cancelled");
  });
  try {
    const s = await we().get("/v3/ua/user/allowed-applications", {
      cancelToken: r.token
    }), { data: l } = s.data;
    return l ?? [];
  } catch (s) {
    return Promise.reject((i = s == null ? void 0 : s.response) == null ? void 0 : i.data);
  }
}, ha = (t) => ke(
  it.keys({
    scope: "getProfileData"
  }),
  fa,
  {
    enabled: t == null ? void 0 : t.enabled,
    staleTime: 1 / 0
  }
), ya = (t) => ke(
  it.keys({
    scope: "getChatBotConfig"
  }),
  ma,
  {
    enabled: t == null ? void 0 : t.enabled,
    staleTime: 1 / 0
  }
), wa = (t) => ke(
  it.keys({
    scope: "getAllowedApplications"
  }),
  ga,
  {
    enabled: t == null ? void 0 : t.enabled,
    staleTime: 1 / 0
  }
), va = {
  Dashboard: {
    applicationId: "a945b49c-0bea-43fd-834f-7d8b0a227f71",
    clientToken: "pub52d840b41891711e1311b7b18dc8e28d"
  },
  Reports: {
    applicationId: "35577291-72a9-4dd2-8257-e0fba0641aa0",
    clientToken: "pub331b24a2b59e5996437941d456ded62a"
  },
  Campaigns: {
    applicationId: "75d9a680-0dc1-4923-b2dc-9aafa44645b7",
    clientToken: "pub52dc1701d8b2678cb0be805f5f617575"
  },
  Creatives: {
    applicationId: "5baf4aa9-eb4d-4865-b08c-2ec81bf0a59e",
    clientToken: "pubea8941296dfacc5df69808a2e6aa8c8f"
  },
  Inventory: {
    applicationId: "43136919-94f8-4d67-9735-856f8f3531de",
    clientToken: "pubf618ff725868f734e22cc26a702d9c1d"
  },
  Audiences: {
    applicationId: "42e38ab2-ff0e-42ba-9f04-af32c0e6987c",
    clientToken: "puba4a498daceeedd3bac2cf658370f8f40"
  },
  "Bid Model": {
    applicationId: "f28e7051-47cb-4b3a-ac9c-2a1d98660edd",
    clientToken: "pub78155a1ca1eb65a60d10cb98dc548586"
  },
  Customers: {
    applicationId: "9f36fc4b-4bde-4d72-b783-eb07ab133683",
    clientToken: "pubca2516fd2166fd85369df4a2ded58531"
  },
  Organization: {
    applicationId: "6178937b-c10d-49b4-a0bd-c4eaa46910a5",
    clientToken: "pub732dae82481272be47a8d1b312ac1f41"
  },
  Conversions: {
    applicationId: "b92bc1af-7007-4397-8239-45bb9d77b679",
    clientToken: "pub7ef50f501372f559c80c976ba50c2243"
  },
  Marketplace: {
    applicationId: "f5257345-06cd-43a3-bf1f-b3c9158d8bf1",
    clientToken: "pube8a851bac1126b5e0244f067b8f2e9cf"
  },
  "Auth Pages": {
    applicationId: "21a993e8-1e45-4bb0-97f2-25cbf66f28c1",
    clientToken: "pubb73ae63e345d0ed7824a96c17c4e644a"
  },
  "My Profile": {
    applicationId: "cdbe2115-0e03-415c-9f43-0eaa215add90",
    clientToken: "pub5f18c00c34087cb1ba249f35c74206a2"
  },
  Insights: {
    applicationId: "",
    clientToken: ""
  },
  Planner: {
    applicationId: "",
    clientToken: ""
  }
};
class ba {
  constructor(e) {
    M(this, "userConfig");
    M(this, "secret");
    M(this, "initDatadog", (e) => {
      if (this.secret.applicationId && this.secret.clientToken) {
        const o = {
          trackUserInteractions: !0,
          traceSampleRate: 100,
          trackViewsManually: !0,
          ...e,
          // cannot override these parameters
          ...this.secret,
          site: "datadoghq.com",
          service: this.userConfig.appName,
          version: this.userConfig.appVersion,
          env: this.userConfig.env
        };
        if (qe.init(o), qe.setUser({
          id: `${this.userConfig.owId}`,
          name: this.userConfig.userName,
          email: this.userConfig.userEmail,
          organization: this.userConfig.organizationName,
          customer_id: `${this.userConfig.owId}`,
          user_email: this.userConfig.userEmail
        }), o.trackViewsManually)
          try {
            qe.startView(window.location.pathname);
          } catch (r) {
            console.error(r);
          }
      }
    });
    this.userConfig = e, this.secret = va[e.appName];
  }
  getDatadogInstance() {
    return qe;
  }
}
const Zt = m.createContext(null), Ia = (t) => {
  const { children: e, dataDogConfig: o } = t, [r, i] = m.useState(
    null
  ), { appMeta: s, appDetails: l } = Ce();
  return m.useEffect(() => {
    const d = new ba({
      appName: l.appName,
      appVersion: l.appVersion,
      env: l.deploymentEnvironment,
      owId: s.loggedInOwId,
      userName: s.userDisplayName,
      userEmail: s.userEmail,
      organizationName: s.organizationName
    });
    d == null || d.initDatadog(o), i(d);
  }, [l, s, i, o]), /* @__PURE__ */ a.jsx(Zt.Provider, { value: r, children: e });
}, Bo = () => {
  const t = m.useContext(Zt);
  t == null || t.getDatadogInstance();
}, xa = {
  alignment: "right",
  horizontal_padding: 20,
  vertical_padding: 20,
  hide_default_launcher: !0
}, Sa = ({
  intercomId: t,
  settings: e = xa
}) => {
  (function() {
    const o = window, r = o.Intercom;
    if (typeof r == "function")
      r("reattach_activator"), r("update", o.intercomSettings);
    else {
      const i = document, s = function(...d) {
        s.c(d);
      };
      s.q = [], s.c = function(d) {
        s.q.push(d);
      }, o.Intercom = s;
      const l = function() {
        const d = i.createElement("script");
        d.type = "text/javascript", d.async = !0, d.src = "https://widget.intercom.io/widget/" + t;
        const c = i.getElementsByTagName("script")[0];
        c.parentNode.insertBefore(d, c);
      };
      document.readyState === "complete" ? l() : o.attachEvent ? o.attachEvent("onload", l) : o.addEventListener("load", l, !1);
    }
  })(), window.intercomSettings = {
    app_id: t,
    ...e
  };
};
class Ra {
  constructor(e) {
    M(this, "parmas");
    M(this, "bootIntercom", () => {
      try {
        window == null || window.Intercom("boot", this.parmas);
      } catch {
        process.env.NODE_ENV !== "production" && console.log("Error booting intercom");
      }
    });
    M(this, "shutdownIntercom", () => {
      var e;
      (e = window.Intercom) == null || e.call(window, "shutdown");
    });
    M(this, "onIntercomShow", (e) => {
      window == null || window.Intercom("onShow", e);
    });
    M(this, "onIntercomHide", (e) => {
      window == null || window.Intercom("onHide", e);
    });
    M(this, "hideIntercom", () => {
      var e;
      (e = window.Intercom) == null || e.call(window, "hide");
    });
    M(this, "showIntercom", () => {
      var e;
      (e = window.Intercom) == null || e.call(window, "show");
    });
    M(this, "onIntercomeUnreadCountChange", (e) => {
      window == null || window.Intercom("onUnreadCountChange", e);
    });
    this.parmas = e;
  }
}
const er = m.createContext(null), ja = () => m.useContext(er), Ca = (t) => {
  const { enableIntercom: e = !0, children: o } = t, { appMeta: r } = Ce(), [i, s] = m.useState(null);
  return m.useEffect(() => {
    let l;
    return e && r.intercomId && (Sa({ intercomId: r.intercomId }), l = new Ra({
      email: r.userEmail,
      intercomId: r.intercomId,
      name: r.userDisplayName,
      owId: r.loggedInOwId
    }), l.bootIntercom(), l.hideIntercom(), s(l)), () => {
      l.shutdownIntercom();
    };
  }, [
    e,
    r.userEmail,
    r.intercomId,
    r.userDisplayName,
    r.loggedInOwId
  ]), /* @__PURE__ */ a.jsx(er.Provider, { value: i, children: o });
}, Aa = (t, e) => {
  const o = new URL("/api", t.originURL), r = ye.create({
    baseURL: o.toString(),
    headers: {
      authorization: `Bearer ${t.token}`,
      [t.owIdHeaderKey]: t.owId
    }
  });
  return e == null || e(r), r;
}, $o = (t) => {
  const {
    appName: e,
    appVersion: o,
    appLink: r,
    appHelpURL: i,
    isAppBeta: s,
    legacyMode: l = !0,
    children: d,
    attachInterceptorsToInstance: c,
    originURLFallback: j,
    deploymentEnvironment: w,
    enableIntercom: A,
    dataDogConfig: S
  } = t, [C, z] = m.useState(!0), [H, te] = m.useState(""), [x, k] = m.useState(
    null
  ), [X, T] = m.useState(
    null
  ), [B, ae] = m.useState(
    null
  ), [G, W] = m.useState(null);
  m.useEffect(() => {
    const ne = ua(), re = new da({
      originURLFallback: j,
      legacyMode: l
    });
    if (ne === null) {
      z(!1), te("Error Validating the user"), process.env.NODE_ENV !== "production" && console.error("failed reading auth details from localstorage");
      return;
    }
    if (re.OwIdFromPath === null) {
      z(!1), te("Error fetching owId");
      return;
    }
    const q = Aa(
      {
        token: ne.accessToken,
        originURL: re.originURL,
        owIdHeaderKey: re.owIdHeaderKey,
        owId: re.OwIdFromPath
      },
      (se) => {
        c == null || c(se), hn(se);
      }
    );
    T(re), W(ne), ae(() => q);
  }, [l, c, j]);
  const V = ha({
    enabled: B !== null
  }), v = wa({
    enabled: B !== null
  }), Z = ya({
    enabled: B !== null
  }), Q = V.isFetching || v.isFetching || Z.isFetching, ee = V.isError || v.isError || Z.isError;
  m.useEffect(() => {
    if (B !== null && !Q) {
      if (ee) {
        z(!1), te("Error loading data"), process.env.NODE_ENV !== "production" && (V.isError && console.error(V.error), v.isError && console.error(v.error), Z.isError && console.error(Z.error));
        return;
      }
      if (V.data && v.data && Z.data && G) {
        if (v.data.find(
          (q) => q.appName === e
        ) === void 0) {
          te("User does not have access to this app"), z(!1);
          return;
        }
        const re = new pa({
          profileData: V.data,
          authData: G,
          intercomId: Z.data.chatbotAppId,
          initAppIstance: X,
          currentApp: e,
          legacyMode: l
        });
        k(re), z(!1);
        return;
      }
      te("Error occured while loading app init data"), z(!1);
    }
  }, [
    Q,
    ee,
    V.data,
    v.data,
    Z.data,
    V.error,
    v.error,
    Z.error,
    V.isError,
    Z.isError,
    v.isError,
    e,
    G,
    B,
    X,
    l
  ]);
  const oe = {
    appVersion: o,
    appName: e,
    appLink: r,
    isAppBeta: s,
    deploymentEnvironment: w,
    appHelpURL: i
  };
  return /* @__PURE__ */ a.jsx(
    ct.Provider,
    {
      value: {
        appInit: X,
        appMeta: x,
        apiInstance: B,
        appDetails: oe,
        allowedApps: v.data ?? []
      },
      children: C ? "App Initialzing..." : H !== "" ? H : /* @__PURE__ */ a.jsx(Ia, { dataDogConfig: S, children: /* @__PURE__ */ a.jsx(Ca, { enableIntercom: A, children: d }) })
    }
  );
}, Ea = {
  [Se.ADVERTISER]: Ee.advertiserUser,
  [Se.WORKSPACE]: Ee.workspaceUser,
  [Se.SUPER]: Ee.superUser
}, _a = m.forwardRef(
  function(e, o) {
    var j;
    const { className: r, ...i } = e, { appMeta: s } = Ce(), [l, d] = m.useState(s.isInfobarEnabled), c = s.organizationHirerachy.map((w) => {
      const A = w;
      return w.isAccess ? /* @__PURE__ */ a.jsx(
        Et,
        {
          className: Ee.link,
          onClick: () => {
            const S = s.prepareOrganizationSwitchingURL(A);
            window.open(S, "_blank");
          },
          children: A.organizationName
        },
        A.owId
      ) : /* @__PURE__ */ a.jsx(U, { children: A.organizationName }, A.owId);
    });
    return l ? /* @__PURE__ */ a.jsxs(
      Ar,
      {
        className: me(
          Ee.root,
          Ea[s.organizationType],
          r
        ),
        ref: o,
        ...i,
        icon: !1,
        variant: "filled",
        onClose: () => d(!1),
        classes: {
          ...i == null ? void 0 : i.classes,
          message: me(Ee.message, (j = i == null ? void 0 : i.classes) == null ? void 0 : j.message)
        },
        children: [
          /* @__PURE__ */ a.jsx(
            at,
            {
              className: Ee.chip,
              size: "small",
              label: s.isUserOrganizationOwner ? "Owner" : "User"
            }
          ),
          /* @__PURE__ */ a.jsx(U, { children: "Logged in as" }),
          /* @__PURE__ */ a.jsx(U, { weight: "demi", children: s.userDisplayName || s.userEmail }),
          /* @__PURE__ */ a.jsx(U, { children: " in " }),
          /* @__PURE__ */ a.jsx(Er, { "aria-label": "breadcrumb", separator: /* @__PURE__ */ a.jsx(on, {}), children: c })
        ]
      }
    ) : null;
  }
);
_a.displayName = "InfoBar";
const ka = "_root_kzc6q_1", Ta = "_title_kzc6q_13", Oa = "_icon_kzc6q_20", La = "_beta_kzc6q_32", Pa = "_content_kzc6q_42", Da = "_nav_kzc6q_49", Na = "_button_kzc6q_56", Ua = "_drawer_kzc6q_63", za = "_appDrawer_kzc6q_76", Fa = "_appList_kzc6q_84", Ma = "_appListItem_kzc6q_95", Ba = "_appListItemLink_kzc6q_100", $a = "_appListItemLinkIcon_kzc6q_114", Wa = "_appListItemLinkText_kzc6q_117", qa = "_active_kzc6q_139", Va = "_disabled_kzc6q_147", Ka = "_profileDrawer_kzc6q_152", Ya = "_user_kzc6q_160", Ha = "_organization_kzc6q_161", Ga = "_avatar_kzc6q_170", Ja = "_info_kzc6q_175", Qa = "_workspace_kzc6q_191", Xa = "_skeleton_kzc6q_195", Za = "_profileList_kzc6q_199", eo = "_profileActions_kzc6q_226", L = {
  root: ka,
  title: Ta,
  icon: Oa,
  beta: La,
  content: Pa,
  nav: Da,
  button: Na,
  drawer: Ua,
  appDrawer: za,
  appList: Fa,
  appListItem: Ma,
  appListItemLink: Ba,
  appListItemLinkIcon: $a,
  appListItemLinkText: Wa,
  active: qa,
  disabled: Va,
  profileDrawer: Ka,
  user: Ya,
  organization: Ha,
  avatar: Ga,
  info: Ja,
  workspace: Qa,
  skeleton: Xa,
  profileList: Za,
  profileActions: eo
}, to = () => {
  const [t, e] = m.useState(!1);
  m.useEffect(() => {
    if (!sessionStorage.getItem("responsiveAlertShown")) {
      const { matches: r } = window.matchMedia("(max-width: 1200px)");
      e(r);
    }
  }, []);
  const o = () => {
    e(!1), sessionStorage.setItem("responsiveAlertShown", "true");
  };
  return /* @__PURE__ */ a.jsx(
    _r,
    {
      maxWidth: "xs",
      open: t,
      onClose: () => e(!1),
      PaperProps: { sx: { py: 32 } },
      children: /* @__PURE__ */ a.jsxs(
        kr,
        {
          sx: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            gap: 12
          },
          children: [
            /* @__PURE__ */ a.jsx(gn, { sx: { width: 50, height: "auto" } }),
            /* @__PURE__ */ a.jsx(
              U,
              {
                component: "h1",
                variant: "h4",
                weight: "demi",
                gutterBottom: !1,
                children: "Want a better Experience?"
              }
            ),
            /* @__PURE__ */ a.jsx(U, { component: "p", gutterBottom: !1, children: "Use a tablet or computer for a better and smoother platform experience." }),
            /* @__PURE__ */ a.jsx(Ke, { onClick: o, children: "Ok, Got It" })
          ]
        }
      )
    }
  );
}, ro = () => {
  const t = ja(), [e, o] = m.useState(!1), [r, i] = m.useState(0);
  return m.useEffect(() => {
    t == null || t.onIntercomShow(() => {
      o(!0);
    }), t == null || t.onIntercomHide(() => {
      o(!1);
    }), t == null || t.onIntercomeUnreadCountChange((s) => {
      i(s);
    });
  }, [t, o]), /* @__PURE__ */ a.jsx(Re, { title: "Chat", arrow: !0, children: /* @__PURE__ */ a.jsx(st, { badgeContent: r, children: /* @__PURE__ */ a.jsx(
    Ue,
    {
      color: "secondary",
      onClick: () => {
        e ? t == null || t.hideIntercom() : t == null || t.showIntercom();
      },
      children: /* @__PURE__ */ a.jsx(sn, {})
    }
  ) }) });
}, tr = () => {
  const t = _t({
    variant: "popper",
    popupId: "appsPopper"
  }), { allowedApps: e, appDetails: o, appMeta: r } = Ce(), i = e.map((s) => {
    const l = Jt[s.appName], d = o.appName === s.appName, c = r.prepareAppSwitchingURL(s);
    return /* @__PURE__ */ a.jsx("li", { className: L.appListItem, children: /* @__PURE__ */ a.jsxs(
      Ge,
      {
        href: c,
        className: me(
          L.appListItemLink,
          d && [L.active]
        ),
        children: [
          /* @__PURE__ */ a.jsx(l, { fontSize: 48, className: L.appListItemLinkIcon }),
          /* @__PURE__ */ a.jsx(
            U,
            {
              component: "h2",
              variant: "bodySmall",
              weight: "demi",
              gutterBottom: !1,
              className: L.appListItemLinkText,
              children: s.appName
            }
          )
        ]
      }
    ) }, s.appId);
  });
  return /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsx(Re, { title: "All your Apps", arrow: !0, children: /* @__PURE__ */ a.jsx(
      Ue,
      {
        color: "secondary",
        ...kt(t),
        selected: t.isOpen,
        children: /* @__PURE__ */ a.jsx(cn, {})
      }
    ) }),
    /* @__PURE__ */ a.jsx(Tt, { ...Ot(t), placement: "bottom-end", children: /* @__PURE__ */ a.jsx(Lt, { onClickAway: t.close, children: /* @__PURE__ */ a.jsx(Pt, { className: me(L.drawer, L.appDrawer), children: /* @__PURE__ */ a.jsx("ul", { className: L.appList, children: i }) }) }) })
  ] });
};
tr.displayName = "AppsDrawer";
const no = async ({
  queryKey: t,
  signal: e,
  pageParam: o = 1
}) => {
  var d;
  const { scope: r, ...i } = t[0], { CancelToken: s } = ye, l = s.source();
  e == null || e.addEventListener("abort", () => {
    l.cancel("/v3/ua/user/allowed-organizations - Request cancelled");
  });
  try {
    const c = await we().get("/v3/ua/user/allowed-organizations", {
      params: {
        ...i,
        pageNo: o
      },
      cancelToken: l.token
    }), { data: j } = c.data;
    return j ?? [];
  } catch (c) {
    return Promise.reject((d = c == null ? void 0 : c.response) == null ? void 0 : d.data);
  }
}, ao = (t) => {
  var e, o;
  (o = Ye) == null || o(
    t.errorObjects ? (e = t.errorObjects[0]) == null ? void 0 : e.error : "Something went wrong!",
    {
      variant: "error"
    }
  );
}, oo = (t, e) => Nt(
  kn.keys({
    ...t,
    scope: "getAllowedOrganizationList"
  }),
  no,
  {
    onError: ao,
    enabled: e == null ? void 0 : e.enabled,
    getNextPageParam: (r, i) => i.reduce((l, d) => {
      var c;
      return l += ((c = d == null ? void 0 : d.data) == null ? void 0 : c.length) ?? 0, l;
    }, 0) < ((r == null ? void 0 : r.filteredRecords) ?? -1) ? i.length + 1 : null
  }
), Ve = (t) => {
  const { variant: e = "allowedOrgs" } = t;
  return /* @__PURE__ */ a.jsxs(Ge, { href: "#", className: me(L.organization, L.skeleton), children: [
    /* @__PURE__ */ a.jsx(
      Pe,
      {
        variant: "circular",
        width: 40,
        height: 40,
        className: L.avatar
      }
    ),
    /* @__PURE__ */ a.jsxs(E, { className: L.info, children: [
      /* @__PURE__ */ a.jsx(Pe, { children: /* @__PURE__ */ a.jsx(
        ue,
        {
          TypgraphyProps: {
            component: "h2",
            variant: "bodyMedium",
            weight: "demi",
            gutterBottom: !1
          },
          arrow: !0,
          children: "User Name - Proflie"
        }
      ) }),
      /* @__PURE__ */ a.jsxs(
        E,
        {
          sx: {
            display: "flex",
            alignItems: "center",
            overflow: "hidden",
            width: 100,
            gap: 4
          },
          children: [
            /* @__PURE__ */ a.jsx(Pe, { children: /* @__PURE__ */ a.jsx(
              ue,
              {
                TypgraphyProps: {
                  component: "h3",
                  variant: "bodySmall",
                  gutterBottom: !1
                },
                arrow: !0,
                children: "userEmail@iqm.comuserEmail@iqm.com"
              }
            ) }),
            e === "allowedOrgs" && /* @__PURE__ */ a.jsx(
              Pe,
              {
                variant: "rounded",
                width: 18,
                height: 18,
                sx: { flexShrink: 0 },
                children: /* @__PURE__ */ a.jsx(Ue, { href: "/copyEmail", sx: { flexShrink: 0 }, size: "small", children: /* @__PURE__ */ a.jsx($t, {}) })
              }
            )
          ]
        }
      ),
      e === "allowedOrgs" && /* @__PURE__ */ a.jsxs(
        E,
        {
          sx: {
            display: "flex",
            alignItems: "center",
            overflow: "hidden",
            width: 100,
            gap: 4
          },
          children: [
            /* @__PURE__ */ a.jsx(Pe, { children: /* @__PURE__ */ a.jsx(
              U,
              {
                component: "label",
                variant: "bodySmall",
                gutterBottom: !1,
                sx: { textColor: "neutral-500", flexShrink: 0 },
                children: "Owner :"
              }
            ) }),
            /* @__PURE__ */ a.jsx(Pe, { children: /* @__PURE__ */ a.jsx(
              ue,
              {
                TypgraphyProps: {
                  component: "h3",
                  variant: "bodySmall",
                  gutterBottom: !1
                },
                arrow: !0,
                children: "Owner User Name"
              }
            ) })
          ]
        }
      )
    ] })
  ] });
}, rr = (t) => t.customerType === "Advertiser" ? Se.ADVERTISER : t.customerType === "Workspace" ? Se.WORKSPACE : Se.SUPER, nr = (t) => t.organizationType === "SUPER" || t.organizationType === "WORKSPACE" ? /* @__PURE__ */ a.jsx(
  st,
  {
    color: "primary",
    overlap: "circular",
    variant: "dot",
    size: "small",
    badgeContent: /* @__PURE__ */ a.jsx(Wt, {}),
    children: /* @__PURE__ */ a.jsx(
      _e,
      {
        size: 40,
        color: "warning",
        className: me(L.avatar, L.workspace),
        src: t.src
      }
    )
  }
) : /* @__PURE__ */ a.jsx(
  _e,
  {
    size: 40,
    color: "primary",
    className: L.avatar,
    src: t.src
  }
), so = (t) => {
  const { organizationDetails: e, prepareOrganizationSwitchingURL: o } = t, r = rr(e), { copy: i } = Tr(e.workspaceDomain);
  return /* @__PURE__ */ a.jsxs(
    Ge,
    {
      className: me(L.organization),
      onClick: () => {
        const s = o(e);
        window.open(s, "_blank");
      },
      children: [
        /* @__PURE__ */ a.jsx(
          nr,
          {
            organizationType: r,
            src: e == null ? void 0 : e.logoUrl
          }
        ),
        /* @__PURE__ */ a.jsxs(E, { className: L.info, children: [
          /* @__PURE__ */ a.jsx(
            ue,
            {
              TypgraphyProps: {
                component: "h2",
                variant: "bodyMedium",
                weight: "demi",
                gutterBottom: !1,
                align: "left"
              },
              arrow: !0,
              children: e == null ? void 0 : e.organizationName
            }
          ),
          /* @__PURE__ */ a.jsxs(
            E,
            {
              sx: {
                display: "flex",
                alignItems: "center",
                overflow: "hidden",
                width: 100,
                gap: 4
              },
              children: [
                /* @__PURE__ */ a.jsx(
                  ue,
                  {
                    TypgraphyProps: {
                      component: "h3",
                      variant: "bodySmall",
                      gutterBottom: !1
                    },
                    arrow: !0,
                    children: r === "WORKSPACE" ? e == null ? void 0 : e.workspaceDomain : e == null ? void 0 : e.workspaceOwnerOrganizationName
                  }
                ),
                r === "WORKSPACE" && /* @__PURE__ */ a.jsx(
                  Ue,
                  {
                    Component: "button",
                    sx: { flexShrink: 0 },
                    size: "small",
                    onClick: (s) => {
                      s.preventDefault(), s.stopPropagation(), i();
                    },
                    children: /* @__PURE__ */ a.jsx($t, {})
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ a.jsxs(
            E,
            {
              sx: {
                display: "flex",
                alignItems: "center",
                overflow: "hidden",
                width: 100,
                gap: 4
              },
              children: [
                /* @__PURE__ */ a.jsx(
                  U,
                  {
                    component: "label",
                    variant: "bodySmall",
                    gutterBottom: !1,
                    sx: { textColor: "neutral-500", flexShrink: 0 },
                    children: "Owner :"
                  }
                ),
                /* @__PURE__ */ a.jsxs(
                  ue,
                  {
                    TypgraphyProps: {
                      component: "h3",
                      variant: "bodySmall",
                      gutterBottom: !1
                    },
                    arrow: !0,
                    children: [
                      e == null ? void 0 : e.contactPersonName,
                      " (",
                      e == null ? void 0 : e.ownerUserEmail,
                      ")"
                    ]
                  }
                )
              ]
            }
          )
        ] })
      ]
    }
  );
}, io = (t) => {
  const e = rr(t);
  return /* @__PURE__ */ a.jsxs(E, { className: L.organization, children: [
    /* @__PURE__ */ a.jsx(
      nr,
      {
        organizationType: e,
        src: t.logoUrl
      }
    ),
    /* @__PURE__ */ a.jsxs(E, { className: L.info, children: [
      /* @__PURE__ */ a.jsx(
        ue,
        {
          TypgraphyProps: {
            component: "h2",
            variant: "bodyMedium",
            weight: "demi",
            gutterBottom: !1
          },
          arrow: !0,
          children: t == null ? void 0 : t.organizationName
        }
      ),
      /* @__PURE__ */ a.jsxs(
        E,
        {
          sx: {
            display: "flex",
            alignItems: "center",
            overflow: "hidden",
            width: 100,
            gap: 4
          },
          children: [
            /* @__PURE__ */ a.jsx(
              U,
              {
                component: "label",
                variant: "bodySmall",
                gutterBottom: !1,
                sx: { textColor: "neutral-500", flexShrink: 0 },
                children: "Owner :"
              }
            ),
            /* @__PURE__ */ a.jsxs(
              ue,
              {
                TypgraphyProps: {
                  component: "h3",
                  variant: "bodySmall",
                  gutterBottom: !1
                },
                arrow: !0,
                children: [
                  t == null ? void 0 : t.contactPersonName,
                  " (",
                  t == null ? void 0 : t.ownerUserEmail,
                  ")"
                ]
              }
            )
          ]
        }
      )
    ] })
  ] });
}, co = () => /* @__PURE__ */ a.jsxs(
  E,
  {
    sx: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      p: 12,
      textAlign: "center",
      height: 100
    },
    children: [
      /* @__PURE__ */ a.jsx(ln, { fontSize: 40, sx: { textColor: "neutral-500" } }),
      /* @__PURE__ */ a.jsx(
        U,
        {
          component: "h2",
          variant: "bodyMedium",
          weight: "demi",
          sx: { my: 8 },
          children: "No results found"
        }
      ),
      /* @__PURE__ */ a.jsx(U, { children: "We can't find any items matching your search" })
    ]
  }
), ar = () => {
  var w, A;
  const t = _t({
    variant: "popper",
    popupId: "profilePopper"
  }), { appMeta: e } = Ce(), [o, r] = m.useState(""), [i, s] = m.useState(null), l = He(o, 200), d = e.prepareAppSwitchingURL({
    appIcon: "logo/my-profile.png",
    appId: NaN,
    appName: "My Profile",
    appUrl: "/accounts"
  }), c = oo({
    isOrganizationAccess: !1,
    limit: 4,
    sortBy: "-lastActive",
    searchField: l
  }), j = m.useMemo(() => {
    var S, C, z, H, te, x;
    return c.isFetching ? /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
      /* @__PURE__ */ a.jsx(Ve, {}, 0),
      /* @__PURE__ */ a.jsx(Ve, {}, 1),
      /* @__PURE__ */ a.jsx(Ve, {}, 2)
    ] }) : (((z = (C = (S = c.data) == null ? void 0 : S.pages) == null ? void 0 : C[0]) == null ? void 0 : z.data.length) ?? 0) > 0 ? (x = (te = (H = c.data) == null ? void 0 : H.pages) == null ? void 0 : te[0]) == null ? void 0 : x.data.map((k) => /* @__PURE__ */ a.jsx(
      so,
      {
        organizationDetails: k,
        prepareOrganizationSwitchingURL: e.prepareOrganizationSwitchingURL
      },
      k.owId
    )) : null;
  }, [
    c.isFetching,
    c.data,
    e.prepareOrganizationSwitchingURL
  ]);
  return m.useEffect(() => {
    var S, C, z;
    c.data && i === null && (z = (C = (S = c == null ? void 0 : c.data) == null ? void 0 : S.pages) == null ? void 0 : C[0]) != null && z.currentOrganization && s(c.data.pages[0].currentOrganization);
  }, [s, c.data, i]), /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsx(Re, { title: "User Name - Proflie", arrow: !0, children: /* @__PURE__ */ a.jsx(
      Ke,
      {
        variant: "text",
        color: "secondary",
        className: L.button,
        startIcon: /* @__PURE__ */ a.jsx(_e, { size: 24, color: "primary", src: e.organizationLogo }),
        ...kt(t),
        selected: t.isOpen,
        children: /* @__PURE__ */ a.jsx(U, { noWrap: !0, gutterBottom: !1, children: e.organizationName })
      }
    ) }),
    /* @__PURE__ */ a.jsx(Tt, { ...Ot(t), placement: "bottom-end", children: /* @__PURE__ */ a.jsx(Lt, { onClickAway: t.close, children: /* @__PURE__ */ a.jsxs(Pt, { className: me(L.drawer, L.profileDrawer), children: [
      /* @__PURE__ */ a.jsxs(E, { className: L.user, children: [
        /* @__PURE__ */ a.jsx(
          _e,
          {
            size: 64,
            color: "primary",
            className: L.avatar,
            src: e.userAvatar
          }
        ),
        /* @__PURE__ */ a.jsxs(E, { className: L.info, children: [
          /* @__PURE__ */ a.jsx(
            ue,
            {
              TypgraphyProps: {
                component: "h2",
                variant: "bodyLarge",
                weight: "demi",
                gutterBottom: !1
              },
              arrow: !0,
              children: e.userDisplayName
            }
          ),
          /* @__PURE__ */ a.jsx(
            ue,
            {
              TypgraphyProps: {
                component: "h3",
                variant: "bodySmall",
                sx: { mb: 4 }
              },
              arrow: !0,
              children: e.userEmail
            }
          ),
          /* @__PURE__ */ a.jsx(Et, { href: d, sx: { textWeight: "demi" }, children: "Manage my profile" })
        ] })
      ] }),
      /* @__PURE__ */ a.jsx(E, { sx: { px: 12 }, children: i === null ? /* @__PURE__ */ a.jsx(Ve, { variant: "currentOrg" }) : /* @__PURE__ */ a.jsx(io, { ...i }) }),
      /* @__PURE__ */ a.jsx(It, { color: "secondary" }),
      /* @__PURE__ */ a.jsx(E, { sx: { px: 12 }, children: /* @__PURE__ */ a.jsx(
        Re,
        {
          title: "Search other organization by name, email or ID",
          placement: "top",
          arrow: !0,
          children: /* @__PURE__ */ a.jsx(
            ot,
            {
              variant: "outlinedDash",
              placeholder: "Search other organization by name, email or ID",
              InputProps: {
                startAdornment: /* @__PURE__ */ a.jsx(un, {})
              },
              onChange: (S) => {
                r(S.target.value);
              },
              fullWidth: !0
            }
          )
        }
      ) }),
      /* @__PURE__ */ a.jsx(E, { className: L.profileList, children: (((A = (w = c.data) == null ? void 0 : w.pages[0]) == null ? void 0 : A.data.length) ?? 0) > 0 || c.isFetching ? j : /* @__PURE__ */ a.jsx(co, {}) }),
      /* @__PURE__ */ a.jsx(It, { color: "secondary" }),
      /* @__PURE__ */ a.jsxs(E, { className: L.profileActions, children: [
        /* @__PURE__ */ a.jsx(
          Ke,
          {
            variant: "outlined",
            Component: "a",
            href: d,
            children: "See all accesses"
          }
        ),
        /* @__PURE__ */ a.jsx(Ke, { children: "Logout" })
      ] })
    ] }) }) })
  ] });
};
ar.displayName = "ProfileDrawer";
const lo = m.forwardRef(
  function(e, o) {
    const { className: r, classes: i, children: s, sx: l, ...d } = e, { appDetails: c, appMeta: j } = Ce(), w = c.appName === "Marketplace" ? () => /* @__PURE__ */ a.jsx("img", { alt: "logo", src: j.organizationLogo }) : Jt[c.appName];
    return /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
      /* @__PURE__ */ a.jsxs(
        E,
        {
          ref: o,
          className: me(L.root, i == null ? void 0 : i.root, r, Dt(l)),
          ...d,
          children: [
            /* @__PURE__ */ a.jsx(
              Re,
              {
                title: c.appVersion ? `${c.appName} - ${c.appVersion}` : "",
                arrow: !0,
                children: /* @__PURE__ */ a.jsxs(
                  Ge,
                  {
                    href: c.appLink,
                    disableRipple: !0,
                    className: L.title,
                    children: [
                      w && /* @__PURE__ */ a.jsx(E, { Component: "span", className: L.icon, children: /* @__PURE__ */ a.jsx(w, {}) }),
                      c.appName && c.appName !== "Marketplace" && /* @__PURE__ */ a.jsx(
                        U,
                        {
                          component: "h1",
                          variant: "h5",
                          weight: "bold",
                          gutterBottom: !1,
                          children: c.appName
                        }
                      ),
                      c.isAppBeta && /* @__PURE__ */ a.jsx(
                        at,
                        {
                          Component: "span",
                          color: "secondary",
                          label: "BETA",
                          size: "exSmall",
                          className: L.beta
                        }
                      )
                    ]
                  }
                )
              }
            ),
            /* @__PURE__ */ a.jsx(E, { className: me(L.content, i == null ? void 0 : i.content), children: s }),
            /* @__PURE__ */ a.jsxs(E, { className: L.nav, children: [
              /* @__PURE__ */ a.jsx(ro, {}),
              /* @__PURE__ */ a.jsx(po, {}),
              /* @__PURE__ */ a.jsx(uo, {}),
              /* @__PURE__ */ a.jsx(tr, {}),
              /* @__PURE__ */ a.jsx(ar, {})
            ] })
          ]
        }
      ),
      /* @__PURE__ */ a.jsx(to, {})
    ] });
  }
);
lo.displayName = "AppBar";
const uo = () => {
  const { appMeta: t } = Ce(), e = t.prepareAppSwitchingURL({
    appIcon: "logo/marketplace.png",
    appId: NaN,
    appName: "Marketplace",
    appUrl: "/marketplace"
  });
  return /* @__PURE__ */ a.jsx(Re, { title: "Home", arrow: !0, children: /* @__PURE__ */ a.jsx(Ue, { color: "secondary", Component: "a", href: e, children: /* @__PURE__ */ a.jsx(dn, {}) }) });
}, po = () => {
  const { appDetails: t } = Ce();
  return t.appHelpURL.length > 0 && /* @__PURE__ */ a.jsx(Re, { title: "Support", arrow: !0, children: /* @__PURE__ */ a.jsx(
    Ue,
    {
      color: "secondary",
      Component: "a",
      href: t.appHelpURL,
      target: "_blank",
      children: /* @__PURE__ */ a.jsx(pn, {})
    }
  ) });
}, fo = "_root_1dkbb_1", mo = {
  root: fo
}, go = m.forwardRef(function(e, o) {
  const {
    className: r,
    classes: i,
    children: s,
    Component: l = "div",
    sx: d,
    ...c
  } = e;
  return /* @__PURE__ */ a.jsx(
    l,
    {
      className: me(mo.root, i == null ? void 0 : i.root, r, Dt(d)),
      ref: o,
      ...c,
      children: s
    }
  );
});
go.displayName = "NotificationBar";
const ho = (t) => {
  if (!Array.isArray(t))
    return [];
  const e = [];
  for (let o = 0; o < t.length; o++) {
    const r = t[o], i = {
      type: "workspace",
      activeCampaignsCount: r.activeCampaignsCount,
      isAccess: r.isAccess,
      logoUrl: r.logoUrl,
      label: r.organizationName,
      value: `${r.owId}`,
      ownerUserEmail: r.ownerUserEmail,
      ownerUserName: r.ownerUserName,
      status: r.status,
      statusId: r.statusId,
      subRows: yo(r.customers)
    };
    e.push(i);
  }
  return e;
}, yo = (t) => {
  if (!Array.isArray(t))
    return [];
  const e = [];
  for (let o = 0; o < t.length; o++) {
    const r = t[o], i = {
      type: "advertiser",
      activeCampaignsCount: r.activeCampaignsCount,
      isAccess: !1,
      logoUrl: r.logoUrl,
      label: r.organizationName,
      value: `${r.owId}`,
      ownerUserEmail: r.ownerUserEmail,
      ownerUserName: r.ownerUserName,
      status: r.status,
      statusId: r.statusId,
      subRows: []
    };
    e.push(i);
  }
  return e;
}, wo = (t) => {
  if (!Array.isArray(t))
    return [];
  const e = [];
  for (let o = 0; o < t.length; o++) {
    const r = t[o], i = {
      type: "workspace",
      activeCampaignsCount: 0,
      isAccess: !1,
      logoUrl: r.logoUrl,
      label: r.workspaceName,
      value: `${r.owId}`,
      ownerUserEmail: r.ownerUserEmail,
      ownerUserName: r.ownerUserName,
      status: r.status,
      statusId: r.statusId,
      subRows: []
    };
    e.push(i);
  }
  return e;
}, At = {
  multiLevel: "/v3/ua/customers/list/multi-level",
  multiLevel2: "/v3/cd/customer/list"
}, vo = async ({
  queryKey: t,
  signal: e,
  pageParam: o = 1
}) => {
  var w;
  const {
    scope: r,
    apiType: i = "multilevel",
    isSelectAll: s = !1,
    ...l
  } = t[0], { CancelToken: d } = ye, c = d.source();
  let j = l;
  if (e == null || e.addEventListener("abort", () => {
    c.cancel(
      `${At[i]} - Request cancelled`
    );
  }), i === "multiLevel2") {
    const { limit: A, ...S } = l;
    j = { ...S, noOfEntries: A };
  }
  try {
    const A = await we().get(At[i], {
      params: {
        ...j,
        pageNo: s === !0 ? -1 : o
      },
      cancelToken: c.token
    }), { data: S, totalRecords: C, filteredRecords: z } = A.data.data;
    return {
      totalRecords: C,
      filteredRecords: z,
      data: ho(S)
    };
  } catch (A) {
    return Promise.reject((w = A == null ? void 0 : A.response) == null ? void 0 : w.data);
  }
}, bo = async ({
  queryKey: t,
  signal: e
}) => {
  var l;
  const { scope: o, ...r } = t[0], { CancelToken: i } = ye, s = i.source();
  e == null || e.addEventListener("abort", () => {
    s.cancel("/v3/ua/customers/workspaces/list - Request cancelled");
  });
  try {
    const d = await we().get("/v3/ua/customers/workspaces/list", {
      params: {
        ...r
      },
      cancelToken: s.token
    }), { data: c } = d.data;
    return {
      totalRecords: c == null ? void 0 : c.length,
      filteredRecords: c == null ? void 0 : c.length,
      data: wo(c ?? [])
    };
  } catch (d) {
    return Promise.reject((l = d == null ? void 0 : d.response) == null ? void 0 : l.data);
  }
}, or = (t) => {
  var e, o;
  (o = Ye) == null || o(
    t.errorObjects ? (e = t.errorObjects[0]) == null ? void 0 : e.error : "Something went wrong!",
    {
      variant: "error"
    }
  );
}, Io = (t, e) => Nt(
  En.keys({
    ...t,
    scope: "getCustomerMultilevelData"
  }),
  vo,
  {
    onError: or,
    enabled: e == null ? void 0 : e.enabled,
    getNextPageParam: (r, i) => i.reduce((l, d) => {
      var c;
      return l += ((c = d == null ? void 0 : d.data) == null ? void 0 : c.length) ?? 0, l;
    }, 0) < ((r == null ? void 0 : r.filteredRecords) ?? -1) ? i.length + 1 : null
  }
), xo = (t, e) => ke(
  _n.keys({
    ...t,
    scope: "getCustomerWorkspaceData"
  }),
  bo,
  {
    onError: or,
    enabled: e == null ? void 0 : e.enabled
  }
), So = "_icons_g3lp7_1", Ro = "_avatarWrapper_g3lp7_6", jo = "_avatar_g3lp7_6", Co = "_workspace_g3lp7_15", Ao = "_advertiser_g3lp7_18", $e = {
  icons: So,
  avatarWrapper: Ro,
  avatar: jo,
  workspace: Co,
  advertiser: Ao
}, Eo = {
  Pending: /* @__PURE__ */ a.jsx(Ft, { color: "warning" }),
  Active: /* @__PURE__ */ a.jsx(fn, { color: "success" }),
  Invited: /* @__PURE__ */ a.jsx(mn, { color: "warning" }),
  Suspened: /* @__PURE__ */ a.jsx(Mt, { color: "warning" }),
  Rejected: /* @__PURE__ */ a.jsx(Bt, { color: "error" })
}, _o = Ne.DefaultListOptionItemWrapper({
  disableCheckbox: !1,
  disableRowExpansion: !1,
  selectionStyle: "all",
  arrowPosition: "right"
}), ko = (t) => {
  const e = (
    // @ts-ignore
    Eo[t.original.status]
  );
  return /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsx(E, { className: $e.avatarWrapper, children: t.original.type === "workspace" ? /* @__PURE__ */ a.jsx(
      st,
      {
        color: "primary",
        overlap: "circular",
        variant: "dot",
        size: "small",
        badgeContent: /* @__PURE__ */ a.jsx(Wt, {}),
        children: /* @__PURE__ */ a.jsx(
          _e,
          {
            size: 36,
            className: me($e.avatar, $e.workspace),
            src: t.original.logoUrl
          }
        )
      }
    ) : /* @__PURE__ */ a.jsx(
      _e,
      {
        size: 36,
        className: me($e.avatar, $e.advertiser),
        src: t.original.logoUrl
      }
    ) }),
    /* @__PURE__ */ a.jsxs(
      E,
      {
        sx: {
          display: "flex",
          flexDirection: "column",
          ml: 8,
          overflow: "hidden",
          width: 100
        },
        children: [
          /* @__PURE__ */ a.jsx(
            ue,
            {
              TypgraphyProps: {
                weight: "demi"
              },
              arrow: !0,
              children: t.original.label
            }
          ),
          /* @__PURE__ */ a.jsxs(E, { sx: { display: "flex", alignItems: "center", gap: 4 }, children: [
            /* @__PURE__ */ a.jsxs(E, { sx: { display: "flex", alignItems: "center", gap: 4 }, children: [
              /* @__PURE__ */ a.jsx(
                U,
                {
                  variant: "label",
                  weight: "demi",
                  lineHeight: "single-line",
                  sx: { textColor: "neutral-500" },
                  children: "ID"
                }
              ),
              /* @__PURE__ */ a.jsx(
                U,
                {
                  component: "span",
                  variant: "label",
                  lineHeight: "single-line",
                  children: t.original.value
                }
              )
            ] }),
            /* @__PURE__ */ a.jsx(
              U,
              {
                sx: { textColor: "neutral-400" },
                lineHeight: "single-line",
                children: "•"
              }
            ),
            /* @__PURE__ */ a.jsxs(
              E,
              {
                sx: {
                  display: "flex",
                  alignItems: "center",
                  gap: 4,
                  fontSize: 14
                },
                children: [
                  e,
                  /* @__PURE__ */ a.jsx(
                    U,
                    {
                      variant: "label",
                      component: "span",
                      lineHeight: "single-line",
                      children: t.original.status
                    }
                  )
                ]
              }
            )
          ] })
        ]
      }
    )
  ] });
}, To = m.forwardRef((t, e) => {
  var he, pe;
  const {
    userType: o = "SUPER",
    filters: r,
    multiple: i = !1,
    slotProps: s,
    /* @ts-ignore */
    apiType: l,
    loggedInOwId: d,
    onChange: c,
    initialData: j,
    TextFieldProps: w,
    ...A
  } = t, S = m.useState(() => t.userType === "WORKSPACE" || t.userType === "SUPER" && (t.apiType === "multiLevel" || t.apiType === "multiLevel2") ? 0 : t.userType === "SUPER" && t.apiType === "workspace" ? 1 : 0)[0], C = Ne.useSelectAdvanceApiRef(), [z, H] = m.useState(""), te = He(z, 250), [x, k] = m.useState({}), X = m.useRef(x);
  X.current = x;
  const T = m.useRef(
    new Map(Object.entries(j ?? {}))
  ), [B, ae] = m.useState(!1), G = m.useCallback(
    (g) => {
      H(g), ae(!1);
    },
    [H]
  ), {
    data: W,
    isLoading: V,
    isFetching: v,
    fetchNextPage: Z
  } = Io(
    {
      ...r,
      apiType: t.userType === "SUPER" ? t.apiType : "",
      limit: Jn,
      searchField: te,
      isSelectAll: B
    },
    {
      enabled: S === 0
      /* multiLevel */
    }
  ), {
    data: Q,
    isLoading: ee,
    isFetching: oe
  } = xo(
    {
      ...r,
      searchField: te
    },
    {
      enabled: S === 1
      /* workspace */
    }
  ), ne = m.useMemo(() => {
    var g, R, $, ce, fe, ve, be, Ie;
    if (o === "WORKSPACE" && S === 0)
      return (R = (g = W == null ? void 0 : W.pages) == null ? void 0 : g[0]) != null && R.data[0] ? ((ce = ($ = W == null ? void 0 : W.pages) == null ? void 0 : $[0]) == null ? void 0 : ce.data[0].value) === `${d}` ? ((be = (ve = (fe = W == null ? void 0 : W.pages) == null ? void 0 : fe[0]) == null ? void 0 : ve.data[0]) == null ? void 0 : be.subRows) ?? [] : [] : [];
    {
      let je = !1;
      return ((Ie = W == null ? void 0 : W.pages) == null ? void 0 : Ie.reduce((Ae, K) => {
        let Te = K.data;
        return je === !1 && (Te = K.data.filter(
          (ze) => ze.value !== `${d}`
        ), Te.length !== K.data.length && (je = !0)), [...Ae, ...Te];
      }, [])) ?? [];
    }
  }, [W, o, S, d]), re = m.useMemo(
    () => ((Q == null ? void 0 : Q.data) ?? []).filter(
      (g) => g.value !== `${d}`
    ),
    [Q, d]
  ), q = S === 0 ? ne : re, se = S === 0 ? V : ee, y = S === 0 ? v : oe;
  m.useEffect(() => {
    if (S === 0 && B && q.length > 0) {
      const g = {};
      T.current.clear(), q.forEach((R) => {
        var $, ce;
        ((($ = R.subRows) == null ? void 0 : $.length) ?? 0) > 0 ? (ce = R.subRows) == null || ce.forEach((fe) => {
          g[fe.value] = !0, T.current.set(fe.value, fe);
        }) : (g[R.value] = !0, T.current.set(R.value, R));
      }), k(g), X.current = g;
    }
  }, [S, B, q]);
  const p = m.useMemo(() => {
    if (!(se || y)) {
      if (!Array.isArray(q))
        return "error";
      if (((q == null ? void 0 : q.length) ?? 0) <= 0)
        return z ? "noResult" : "noRows";
    }
  }, [q, se, y, z]), h = () => {
    const g = T.current.entries(), R = C.current.tableInstance.getRowModel().rowsById, $ = {};
    for (const ce of g) {
      const [fe, ve] = ce;
      R[fe] && ($[fe] = ve);
    }
    return $;
  }, I = (g) => {
    var je, Ae;
    const R = typeof g == "function" ? g(x) : g;
    if (i === !1) {
      const K = Object.keys(R)[0], ze = (je = C.current.tableInstance.getRowModel().rowsById[K]) == null ? void 0 : je.original;
      T.current.clear(), T.current.set(K, ze), k(g), typeof c == "function" && c(
        Object.fromEntries(T.current.entries()),
        "userAction"
      );
      return;
    }
    const $ = Object.keys(R), ce = h(), fe = Object.keys(ce), ve = C.current.tableInstance.getRowModel().rowsById, be = $.filter(
      (K) => ce[K] === void 0
    ), Ie = fe.filter(
      (K) => R[K] === void 0
    );
    for (const K of be)
      (Ae = ve[K]) != null && Ae.original && T.current.set(K, ve[K].original);
    for (const K of Ie)
      T.current.delete(K);
    k(g), typeof c == "function" && c(
      Object.fromEntries(T.current.entries()),
      "userAction"
    );
  }, P = (g) => {
    T.current.delete(g);
    const R = { ...x };
    delete R[g], k(R), typeof c == "function" && c(
      Object.fromEntries(T.current.entries()),
      "apiAction"
    );
  }, N = (g) => {
    try {
      const R = C.current.tableInstance.getRow(g);
      R && (T.current.set(R.id, R.original), k({ ...x, [R.id]: !0 }), typeof c == "function" && c(
        Object.fromEntries(T.current.entries()),
        "apiAction"
      ));
    } catch (R) {
      console.log(R), console.log("cannot add row that is not part of current dataset");
    }
  }, ie = (g) => {
    const R = {};
    T.current.clear();
    for (const [$, ce] of Object.entries(g))
      R[$] = !0, T.current.set($, ce);
    k(R), typeof c == "function" && c(
      Object.fromEntries(T.current.entries()),
      "apiAction"
    );
  }, de = () => {
    G(""), k({}), X.current = {}, T.current.clear();
  };
  return m.useImperativeHandle(e, () => ({
    getRowSelection: () => X.current,
    getRowSelectionData: () => T.current,
    getCurrentData: () => q,
    removeSelection: P,
    setSelection: N,
    reinitializeRowSelection: ie,
    setSearch: G,
    reset: de
  })), /* @__PURE__ */ a.jsx(
    ot,
    {
      ...w,
      select: "advanceSelect",
      placeholder: "Select Customer",
      SelectProps: {
        slotProps: {
          ...s,
          InputBaseProps: {
            placeholder: "Search by Organization, Customer ID, Status or Email",
            ...s == null ? void 0 : s.InputBaseProps
          }
        },
        ...A,
        data: q,
        apiRef: C,
        inputValue: z,
        multiple: i,
        loading: se || y,
        enableSubRowSelection: !0,
        getSubRows: (g) => {
          var R;
          return (((R = g.subRows) == null ? void 0 : R.length) ?? 0) > 0 ? g.subRows : void 0;
        },
        getRowCanExpand: (g) => {
          var R, $;
          return ((($ = (R = g.original) == null ? void 0 : R.subRows) == null ? void 0 : $.length) ?? 0) > 0;
        },
        overlay: p,
        onInputChange: (g, R, $) => {
          $ !== "reset" && G(R);
        },
        ...o === "SUPER" && S === 0 ? {
          rowCount: (((pe = (he = W == null ? void 0 : W.pages) == null ? void 0 : he[0]) == null ? void 0 : pe.filteredRecords) ?? 1) - 1,
          onFetchRows: () => Z()
        } : {},
        renderValue: () => {
          const g = Object.keys(X.current);
          if (i)
            return g.length ? `${g.length} Selected` : "​";
          {
            const R = g[0] ?? "", $ = T.current.get(R);
            return /* @__PURE__ */ a.jsx(
              ue,
              {
                TypgraphyProps: {
                  component: "span"
                },
                children: ($ == null ? void 0 : $.label) ?? "​"
              }
            );
          }
        },
        renderListItem: _o,
        renderOption: ({ row: g }) => ko(g),
        onSelectAll: (g) => {
          g && ae(!0);
        }
      },
      value: x,
      onChange: I
    }
  );
});
To.displayName = "CustomerDropdown";
export {
  lo as AppBar,
  ct as AppContext,
  $o as AppProvider,
  To as CustomerDropdown,
  _a as InfoBar,
  go as NotificationBar,
  to as ResponsiveExperinceAlert,
  Gn as SelectIOCampaignList,
  zn as SelectPrebidSegment,
  hn as attachInstance,
  vn as constructProviderDataFromSearchResults,
  we as getInstance,
  Mn as normalizeCampaignData,
  Fn as normalizeIOCampaignData,
  wo as normalizeWorkspaceData,
  ho as normalizeWorkspaceMultilevelData,
  Yt as transformChildSegmentData,
  Bn as transformIOCampaignInitDataToRowSelection,
  yn as transformInitDataToRowSelection,
  Kt as transformParentProviderData,
  wn as transformSearchSegmentData,
  Ce as useAppContext,
  Bo as useDataDog,
  ja as useIntercom,
  Tn as usePrebidProviderData,
  On as usePrebidSearchSegmentData
};
//# sourceMappingURL=index.js.map
